import { colorAppBackground } from '../config/theme';

export const DownloadIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LibraryIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.9004L11.8999 21.7503C11.2053 20.7083 10.858 20.1874 10.3991 19.8102C9.99286 19.4763 9.52476 19.2258 9.02161 19.073C8.45325 18.9004 7.82711 18.9004 6.57482 18.9004H5.2C4.07989 18.9004 3.51984 18.9004 3.09202 18.6824C2.71569 18.4907 2.40973 18.1847 2.21799 17.8084C2 17.3805 2 16.8205 2 15.7004V7.10039C2 5.98029 2 5.42023 2.21799 4.99241C2.40973 4.61609 2.71569 4.31012 3.09202 4.11838C3.51984 3.90039 4.07989 3.90039 5.2 3.90039H5.6C7.84021 3.90039 8.96031 3.90039 9.81596 4.33636C10.5686 4.71986 11.1805 5.33178 11.564 6.08443C12 6.94008 12 8.06018 12 10.3004M12 21.9004V10.3004M12 21.9004L12.1001 21.7503C12.7947 20.7083 13.142 20.1874 13.6009 19.8102C14.0071 19.4763 14.4752 19.2258 14.9784 19.073C15.5467 18.9004 16.1729 18.9004 17.4252 18.9004H18.8C19.9201 18.9004 20.4802 18.9004 20.908 18.6824C21.2843 18.4907 21.5903 18.1847 21.782 17.8084C22 17.3805 22 16.8205 22 15.7004V7.10039C22 5.98029 22 5.42023 21.782 4.99241C21.5903 4.61609 21.2843 4.31012 20.908 4.11838C20.4802 3.90039 19.9201 3.90039 18.8 3.90039H18.4C16.1598 3.90039 15.0397 3.90039 14.184 4.33636C13.4314 4.71986 12.8195 5.33178 12.436 6.08443C12 6.94008 12 8.06018 12 10.3004"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FavouriteIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9932 4.03621C8.9938 1.69879 5.65975 1.07003 3.15469 3.2104C0.649644 5.35077 0.296968 8.92937 2.2642 11.4608C3.89982 13.5655 8.84977 18.0045 10.4721 19.4412C10.6536 19.602 10.7444 19.6823 10.8502 19.7139C10.9426 19.7415 11.0437 19.7415 11.1361 19.7139C11.2419 19.6823 11.3327 19.602 11.5142 19.4412C13.1365 18.0045 18.0865 13.5655 19.7221 11.4608C21.6893 8.92937 21.3797 5.32826 18.8316 3.2104C16.2835 1.09255 12.9925 1.69879 10.9932 4.03621Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HistoryIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7 12.4004L18.7005 10.4004L16.7 12.4004M19 10.9004C19 15.871 14.9706 19.9004 10 19.9004C5.02944 19.9004 1 15.871 1 10.9004C1 5.92983 5.02944 1.90039 10 1.90039C13.3019 1.90039 16.1885 3.67853 17.7545 6.32948M10 5.90039V10.9004L13 12.9004"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RubricIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83329 7.33337H5.83329M7.16663 10H5.83329M11.1666 4.66671H5.83329M13.8333 7.00004V4.53337C13.8333 3.41327 13.8333 2.85322 13.6153 2.42539C13.4236 2.04907 13.1176 1.74311 12.7413 1.55136C12.3135 1.33337 11.7534 1.33337 10.6333 1.33337H6.36663C5.24652 1.33337 4.68647 1.33337 4.25865 1.55136C3.88232 1.74311 3.57636 2.04907 3.38461 2.42539C3.16663 2.85322 3.16663 3.41327 3.16663 4.53337V11.4667C3.16663 12.5868 3.16663 13.1469 3.38461 13.5747C3.57636 13.951 3.88232 14.257 4.25865 14.4487C4.68647 14.6667 5.24652 14.6667 6.36663 14.6667H8.16663M15.1666 14.6667L14.1666 13.6667M14.8333 12C14.8333 13.2887 13.7886 14.3334 12.5 14.3334C11.2113 14.3334 10.1666 13.2887 10.1666 12C10.1666 10.7114 11.2113 9.66671 12.5 9.66671C13.7886 9.66671 14.8333 10.7114 14.8333 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FlowIcon = ({ color = '#000' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.83337 3.00004H11.7C12.4468 3.00004 12.8201 3.00004 13.1054 3.14537C13.3562 3.2732 13.5602 3.47717 13.688 3.72805C13.8334 4.01327 13.8334 4.38664 13.8334 5.13337V6.00004C13.8334 6.6213 13.8334 6.93192 13.7319 7.17695C13.5966 7.50366 13.337 7.76322 13.0103 7.89855C12.7653 8.00004 12.4546 8.00004 11.8334 8.00004M8.16671 13H3.30004C2.5533 13 2.17994 13 1.89472 12.8547C1.64384 12.7269 1.43986 12.5229 1.31203 12.272C1.16671 11.9868 1.16671 11.6134 1.16671 10.8667V10C1.16671 9.37879 1.16671 9.06816 1.2682 8.82313C1.40353 8.49643 1.66309 8.23686 1.9898 8.10153C2.23482 8.00004 2.54545 8.00004 3.16671 8.00004M6.36671 9.66671H8.63337C8.82006 9.66671 8.9134 9.66671 8.9847 9.63038C9.04743 9.59842 9.09842 9.54743 9.13038 9.4847C9.16671 9.4134 9.16671 9.32006 9.16671 9.13337V6.86671C9.16671 6.68002 9.16671 6.58668 9.13038 6.51538C9.09842 6.45266 9.04743 6.40166 8.9847 6.36971C8.9134 6.33337 8.82006 6.33337 8.63337 6.33337H6.36671C6.18002 6.33337 6.08668 6.33337 6.01538 6.36971C5.95266 6.40166 5.90166 6.45266 5.86971 6.51538C5.83337 6.58668 5.83337 6.68002 5.83337 6.86671V9.13337C5.83337 9.32006 5.83337 9.4134 5.86971 9.4847C5.90166 9.54743 5.95266 9.59842 6.01538 9.63038C6.08668 9.66671 6.18002 9.66671 6.36671 9.66671ZM11.3667 14.6667H13.6334C13.8201 14.6667 13.9134 14.6667 13.9847 14.6304C14.0474 14.5984 14.0984 14.5474 14.1304 14.4847C14.1667 14.4134 14.1667 14.3201 14.1667 14.1334V11.8667C14.1667 11.68 14.1667 11.5867 14.1304 11.5154C14.0984 11.4527 14.0474 11.4017 13.9847 11.3697C13.9134 11.3334 13.8201 11.3334 13.6334 11.3334H11.3667C11.18 11.3334 11.0867 11.3334 11.0154 11.3697C10.9527 11.4017 10.9017 11.4527 10.8697 11.5154C10.8334 11.5867 10.8334 11.68 10.8334 11.8667V14.1334C10.8334 14.3201 10.8334 14.4134 10.8697 14.4847C10.9017 14.5474 10.9527 14.5984 11.0154 14.6304C11.0867 14.6667 11.18 14.6667 11.3667 14.6667ZM1.36671 4.66671H3.63337C3.82006 4.66671 3.9134 4.66671 3.9847 4.63038C4.04743 4.59842 4.09842 4.54743 4.13038 4.4847C4.16671 4.4134 4.16671 4.32006 4.16671 4.13337V1.86671C4.16671 1.68002 4.16671 1.58668 4.13038 1.51538C4.09842 1.45266 4.04743 1.40166 3.9847 1.36971C3.9134 1.33337 3.82006 1.33337 3.63337 1.33337H1.36671C1.18002 1.33337 1.08668 1.33337 1.01538 1.36971C0.952656 1.40166 0.901663 1.45266 0.869705 1.51538C0.833374 1.58668 0.833374 1.68002 0.833374 1.86671V4.13337C0.833374 4.32006 0.833374 4.4134 0.869705 4.4847C0.901663 4.54743 0.952656 4.59842 1.01538 4.63038C1.08668 4.66671 1.18002 4.66671 1.36671 4.66671Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ color = 'black' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.87601 18.1157C2.92195 17.7022 2.94493 17.4955 3.00748 17.3022C3.06298 17.1308 3.1414 16.9676 3.24061 16.8172C3.35242 16.6476 3.49952 16.5005 3.7937 16.2063L17 3.00006C18.1046 1.89549 19.8954 1.89549 21 3.00006C22.1046 4.10463 22.1046 5.89549 21 7.00006L7.7937 20.2063C7.49951 20.5005 7.35242 20.6476 7.18286 20.7594C7.03242 20.8586 6.86926 20.937 6.69782 20.9925C6.50457 21.0551 6.29783 21.0781 5.88434 21.124L2.49997 21.5001L2.87601 18.1157Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = ({ color = 'black' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4M6.66667 7V10.3333M9.33333 7V10.3333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadUserIcon = ({ color = 'black' }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 18L19 15M19 15L22 18M19 15V21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadUserIcon = ({ color = 'black' }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 18L19 21M19 21L22 18M19 21V15M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserCheckIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserXIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 16L21.5 21M21.5 16L16.5 21M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarCheck = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ListViewIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 10H3M21 18H3M21 6H3M21 14H3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronIcon = ({ color = 'black' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 12.5L10 7.5L5 12.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserGroupIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserGroupCheckIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 18L18 20L22 16M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserGroupRemoveIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 16L21.5 21M21.5 16L16.5 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleCheckIcon = ({ color = 'black' }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M53 25.7143V28.0143C52.9969 33.4054 51.2513 38.651 48.0233 42.9689C44.7954 47.2867 40.2582 50.4455 35.0884 51.9741C29.9186 53.5026 24.3931 53.3191 19.3362 51.4508C14.2792 49.5825 9.96164 46.1296 7.0274 41.607C4.09317 37.0844 2.69948 31.7345 3.05419 26.3551C3.40891 20.9757 5.49302 15.8551 8.9957 11.757C12.4984 7.65886 17.232 4.80277 22.4905 3.61467C27.749 2.42658 33.2507 2.97015 38.175 5.16431M53 8L28 33.025L20.5 25.525"
      stroke={color}
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 7L7 17M7 7L17 17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlertCircleIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileSearchIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookOpenIcon = ({ color = 'black' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 21.8999L12.3999 21.7498C11.7053 20.7079 11.358 20.1869 10.8991 19.8097C10.4929 19.4758 10.0248 19.2253 9.52161 19.0725C8.95325 18.8999 8.32711 18.8999 7.07482 18.8999H5.7C4.57989 18.8999 4.01984 18.8999 3.59202 18.6819C3.21569 18.4902 2.90973 18.1842 2.71799 17.8079C2.5 17.3801 2.5 16.82 2.5 15.6999V7.0999C2.5 5.9798 2.5 5.41974 2.71799 4.99192C2.90973 4.6156 3.21569 4.30964 3.59202 4.11789C4.01984 3.8999 4.57989 3.8999 5.7 3.8999H6.1C8.34021 3.8999 9.46031 3.8999 10.316 4.33588C11.0686 4.71937 11.6805 5.33129 12.064 6.08394C12.5 6.93959 12.5 8.05969 12.5 10.2999M12.5 21.8999V10.2999M12.5 21.8999L12.6001 21.7498C13.2947 20.7079 13.642 20.1869 14.1009 19.8097C14.5071 19.4758 14.9752 19.2253 15.4784 19.0725C16.0467 18.8999 16.6729 18.8999 17.9252 18.8999H19.3C20.4201 18.8999 20.9802 18.8999 21.408 18.6819C21.7843 18.4902 22.0903 18.1842 22.282 17.8079C22.5 17.3801 22.5 16.82 22.5 15.6999V7.0999C22.5 5.9798 22.5 5.41974 22.282 4.99192C22.0903 4.6156 21.7843 4.30964 21.408 4.11789C20.9802 3.8999 20.4201 3.8999 19.3 3.8999H18.9C16.6598 3.8999 15.5397 3.8999 14.684 4.33588C13.9314 4.71937 13.3195 5.33129 12.936 6.08394C12.5 6.93959 12.5 8.05969 12.5 10.2999"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = ({ color = 'black' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5 10.8999H3.5M16.5 2.8999V6.8999M8.5 2.8999V6.8999M9.5 16.8999L11.5 18.8999L16 14.3999M8.3 22.8999H16.7C18.3802 22.8999 19.2202 22.8999 19.862 22.5729C20.4265 22.2853 20.8854 21.8264 21.173 21.2619C21.5 20.6201 21.5 19.7801 21.5 18.0999V9.6999C21.5 8.01974 21.5 7.17967 21.173 6.53793C20.8854 5.97344 20.4265 5.5145 19.862 5.22688C19.2202 4.8999 18.3802 4.8999 16.7 4.8999H8.3C6.61984 4.8999 5.77976 4.8999 5.13803 5.22688C4.57354 5.5145 4.1146 5.97344 3.82698 6.53793C3.5 7.17967 3.5 8.01974 3.5 9.6999V18.0999C3.5 19.7801 3.5 20.6201 3.82698 21.2619C4.1146 21.8264 4.57354 22.2853 5.13803 22.5729C5.77976 22.8999 6.61984 22.8999 8.3 22.8999Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GiveFeedBackIcon = ({ color = 'black' }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 4.90013H7.3C5.61984 4.90013 4.77976 4.90013 4.13803 5.22711C3.57354 5.51473 3.1146 5.97367 2.82698 6.53816C2.5 7.17989 2.5 8.01997 2.5 9.70013V18.1001C2.5 19.7803 2.5 20.6204 2.82698 21.2621C3.1146 21.8266 3.57354 22.2855 4.13803 22.5731C4.77976 22.9001 5.61984 22.9001 7.3 22.9001H15.7C17.3802 22.9001 18.2202 22.9001 18.862 22.5731C19.4265 22.2855 19.8854 21.8266 20.173 21.2621C20.5 20.6204 20.5 19.7803 20.5 18.1001V13.9001M8.49997 16.9001H10.1745C10.6637 16.9001 10.9083 16.9001 11.1385 16.8449C11.3425 16.7959 11.5376 16.7151 11.7166 16.6054C11.9184 16.4817 12.0914 16.3088 12.4373 15.9629L22 6.40013C22.8284 5.5717 22.8284 4.22856 22 3.40013C21.1716 2.5717 19.8284 2.5717 19 3.40013L9.43723 12.9629C9.09133 13.3088 8.91838 13.4817 8.79469 13.6836C8.68504 13.8625 8.60423 14.0576 8.55523 14.2617C8.49997 14.4918 8.49997 14.7364 8.49997 15.2256V16.9001Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserAddIcon = () => {
  return (
    <svg
      width="47"
      height="48"
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.4645 32.0178C28.8861 31.6825 30.9128 31.2597 30.9635 30.9447H33.6391C34.8721 30.9447 35.8804 30.3149 35.8804 29.5441C35.8804 28.7733 34.8721 28.1435 33.6391 28.1435H30.8785C30.5902 27.412 30.5902 26.9498 30.8785 26.2197H31.3966C32.5178 26.2197 33.4347 25.647 33.4347 24.946C33.4347 24.2451 32.5178 23.6724 31.3966 23.6724H14.6854C13.5642 23.6724 12.6474 24.2451 12.6474 24.946C12.6474 25.647 13.5642 26.2197 14.6854 26.2197H15.5781C15.8486 26.9511 15.8486 27.4133 15.5781 28.1435H6.32989C5.09688 28.1435 4.08862 28.7733 4.08862 29.5441C4.08862 30.3149 5.09688 30.9447 6.32989 30.9447H14.9128C14.9635 31.28 12.9661 31.6482 13.2975 32.0038"
        fill="#FCEBC5"
      />
      <path
        d="M31.8041 31.7981H37.8752C39.1082 31.7981 40.1165 32.4279 40.1165 33.1987C40.1165 33.9695 39.1082 34.5994 37.8752 34.5994H34.7615C34.6244 35.506 34.7425 36.6463 35.1158 37.1454H35.7546C36.9876 37.1454 37.9958 37.7752 37.9958 38.546C37.9958 39.3168 36.9876 39.9467 35.7546 39.9467L10.9292 40.2756C9.69614 40.2756 8.58249 39.6381 8.68788 38.8749C8.99518 36.64 14.8758 37.2 16.0377 37.1505C16.439 36.654 13.3888 35.5086 13.2415 34.5994H10.566C9.33296 34.5994 8.32471 33.9695 8.32471 33.1987C8.32471 32.4279 9.33296 31.7981 10.566 31.7981H31.8041Z"
        fill="#FCEBC5"
      />
      <path
        d="M12.3184 41.0019C12.0136 35.3575 12.5584 30.0889 20.2765 27.9975L15.9095 23.1454L16.298 18.0026L21.0536 14.5092L25.6149 15.1886L26.1977 13.8299L27.7507 13.054L29.3038 13.5391L31.5361 12.0483L32.7006 9.85144L34.7387 9.94795L35.9996 12.3746L38.1342 13.7333L40.3666 13.1505L41.9196 15.3829L40.0758 17.1302L40.3666 19.8476L41.7253 21.3029L40.9495 24.0203L38.1838 23.3892L35.7571 24.9422L35.3685 27.2711L33.2339 27.3676L31.5361 26.4025L31.8752 24.9422L28.8669 23.3892L26.9266 26.4952L24.5977 27.854C31.3469 28.9918 33.2149 34.0406 32.7501 40.9549L12.3222 41.0032L12.3184 41.0019Z"
        fill="#FCEBC5"
      />
      <path
        d="M33.7521 21.4959C35.3602 21.4959 36.6638 20.1922 36.6638 18.5841C36.6638 16.976 35.3602 15.6724 33.7521 15.6724C32.144 15.6724 30.8403 16.976 30.8403 18.5841C30.8403 20.1922 32.144 21.4959 33.7521 21.4959Z"
        fill="#F8D88B"
      />
      <path
        d="M12.3184 41.0019C11.8244 35.2178 12.966 30.1879 20.2765 27.9975L24.5952 27.8514C31.1413 30.0483 34.1914 34.2273 32.7476 40.9524L12.3197 41.0006L12.3184 41.0019Z"
        fill="#F8D88B"
      />
      <path
        d="M11.6085 37.3701V41.1809C11.6085 41.5657 11.9158 41.8349 12.3019 41.8743H32.8949C33.2796 41.8743 33.5488 41.567 33.5882 41.1809V37.3701C33.5882 32.8279 30.5863 28.8635 26.2358 27.5924C27.5831 26.8609 28.6612 25.7066 29.3152 24.3593C29.893 24.8216 30.5469 25.1682 31.2009 25.3981V26.2451C31.2009 27.2076 31.9704 28.0152 32.9711 28.0152H34.5114C35.4739 28.0152 36.2815 27.2457 36.2815 26.2451V25.3981C37.0511 25.1289 37.7444 24.7047 38.3984 24.2044L39.1298 24.6273C39.9768 25.0895 41.0549 24.8203 41.5158 23.9733L42.2853 22.6641C42.7857 21.8171 42.4784 20.739 41.6314 20.2387L40.8999 19.8159C40.9774 19.4311 41.0155 19.007 41.0155 18.6222C41.0155 18.2374 40.9774 17.8133 40.8999 17.4286L41.6314 17.0057C42.4784 16.5435 42.7857 15.4654 42.2853 14.6197C42.2473 14.5816 42.1317 14.3886 41.5158 13.3105C41.0155 12.4635 39.9755 12.1943 39.1298 12.6565L38.3984 13.0793C37.7825 12.579 37.0511 12.1562 36.2815 11.8857V11.0387C36.2815 10.0762 35.512 9.26855 34.5114 9.26855H32.9711C32.0085 9.26855 31.2009 10.0381 31.2009 11.0387V11.8857C30.4314 12.1549 29.738 12.579 29.0841 13.0793L28.3526 12.6565C27.5057 12.1943 26.4276 12.4635 25.9666 13.3105L25.4282 14.2336C24.5431 13.8489 23.5806 13.6952 22.618 13.6952C18.538 13.6952 15.1895 16.9676 15.1895 21.0476C15.1895 23.7422 16.6523 26.2438 19.0003 27.553C14.6117 28.8228 11.6098 32.8266 11.6098 37.3689L11.6085 37.3701ZM26.7996 13.8133C26.9203 13.6127 27.1603 13.5327 27.4015 13.6533L28.6041 14.3352C28.8847 14.4952 29.206 14.4559 29.446 14.2552C30.1673 13.5733 31.0092 13.092 31.9717 12.8114C32.2523 12.7314 32.4923 12.4508 32.4923 12.1295V10.767C32.4923 10.527 32.693 10.3263 32.933 10.3263H34.5368C34.7768 10.3263 34.9774 10.527 34.9774 10.767V12.1295C34.9774 12.4508 35.178 12.7314 35.498 12.8114C36.4199 13.092 37.3025 13.5733 38.0238 14.2552C38.2638 14.4559 38.585 14.4952 38.8657 14.3352L40.0682 13.6533C40.2688 13.5327 40.5495 13.6127 40.6701 13.8133L41.4714 15.1759C41.592 15.3765 41.512 15.6571 41.3114 15.7371L40.1088 16.419C39.8282 16.579 39.7076 16.9003 39.7876 17.1809C40.0276 18.1435 40.0276 19.1047 39.7876 20.0673C39.7076 20.3886 39.8676 20.7086 40.1088 20.8292L41.3114 21.5111C41.512 21.6317 41.592 21.8717 41.4714 22.113L40.6701 23.4755C40.5495 23.6762 40.3095 23.7562 40.1088 23.6355L38.9063 22.9536C38.6257 22.7936 38.3044 22.833 38.0644 23.0336C37.3431 23.7155 36.5012 24.1968 35.5387 24.4774C35.2174 24.5574 35.018 24.8381 35.018 25.1593V26.5219C35.018 26.7619 34.8174 26.9625 34.5774 26.9625H32.9736C32.7336 26.9625 32.533 26.7619 32.533 26.5219V25.1593C32.533 24.8381 32.3323 24.5574 32.0123 24.4774C31.1298 24.2374 30.3285 23.7955 29.6466 23.1949C29.8066 22.5536 29.8866 21.7917 29.8866 21.2305C29.8866 18.5041 28.4428 16.099 26.3184 14.7365L26.7996 13.8146V13.8133ZM16.3438 21.0882C16.3438 17.6546 19.1463 14.8914 22.5799 14.8914C26.0136 14.8914 28.8161 17.694 28.8161 21.0882C28.8161 24.4825 26.3692 27.3244 22.5406 27.3244C19.1463 27.3244 16.3438 24.5219 16.3438 21.0882ZM21.7863 28.3314C21.8663 28.3314 23.4536 28.3314 23.3736 28.3314C28.4149 28.3314 32.5038 32.4203 32.5038 37.4616V40.6768H12.6549V37.4616C12.6549 32.4203 16.7438 28.3314 21.785 28.3314H21.7863Z"
        fill="#E88236"
      />
      <path
        d="M33.7039 22.3962C35.7826 22.3962 37.4372 20.7022 37.4372 18.6235C37.4372 16.5447 35.7432 14.8901 33.6645 14.8901C31.5858 14.8901 29.9312 16.5841 29.9312 18.6628C29.9312 20.7416 31.6251 22.3962 33.7039 22.3962ZM33.7064 15.887C35.2492 15.887 36.4404 17.1657 36.4404 18.6654C36.4404 20.1651 35.1616 21.3993 33.6619 21.3993C32.1623 21.3993 30.928 20.1651 30.928 18.6209C30.928 17.0768 32.1623 15.8425 33.7064 15.887Z"
        fill="#E88236"
      />
    </svg>
  );
};

export const TeacherEvaluationIcon = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6.99999L14 6.95264V18.1429L12 22L10 17.7143V6.99999Z"
        fill="#F8D88B"
      />
      <path
        d="M10.8883 25.0603L12.5826 25.4839H14.2768L14.7004 22.9425H17.6654L18.0889 25.4839H19.3596L20.6303 24.6368L23.5953 28.0253L24.0189 30.9903L21.0539 33.5317L22.3246 35.2259L20.6303 36.9202L18.5125 36.0731H18.0889L17.2418 38.1909L15.124 38.6145H14.7004L14.2768 36.4966L13.0061 36.0731L11.7354 36.9202L9.61761 36.0731L10.4647 33.9552V32.261L7.92334 31.8374V29.7196L10.4647 29.296L10.0412 25.9075L10.8883 25.0603Z"
        fill="#F8D88B"
      />
      <path
        d="M20.243 6L32.9142 6.84713L36.0283 9.94858L37.5734 11.0828L38.8441 12.7771L40.1148 14.0478V24.6369V36.9204L39.6913 38.1911L38.4206 38.6147H37.1499H35.8792L36.7263 39.0382H35.8792L35.4556 38.6147H34.6084H34.1849H33.7732L33.5495 39.0382L32.5965 38.6147H31.9612H31.3258H30.3728H29.7374H28.7844H28.1491H27.5137H26.243H24.9723L23.1423 38.1911L20.2072 39.0382L18.3011 38.1911L18.1544 36.2692L19.7836 36.4968L21.0543 36.9204L21.9014 35.6497L21.4779 32.6847L23.1721 31.8376L24.0193 30.9904L23.5957 29.7197L22.325 29.2962L21.0543 27.6019L21.9014 26.3312L21.0543 24.6369L18.5129 25.0605L18.0893 19.5541L17.6658 8.88278L18.3101 6.48046L19.5987 6H20.243Z"
        fill="#FCEBC5"
      />
      <path
        d="M9.31549 36.0859L10.6123 37.3826C10.7679 37.5382 11.0272 37.5901 11.2347 37.4864L13.0502 36.6046C13.3096 36.7602 13.6208 36.8639 13.8802 36.9677L14.5026 38.8869C14.5545 39.0944 14.762 39.25 14.9695 39.25H16.8368C17.0443 39.25 17.2518 39.0944 17.3037 38.8869L17.7186 37.5901L18.0299 38.4719C18.0299 38.5238 18.0817 38.5757 18.1336 38.6275C18.4967 39.0425 19.0154 39.25 19.586 39.25H38.6227C39.7639 39.25 40.6457 38.3163 40.6457 37.227C40.6457 37.1233 40.6457 13.9368 40.6457 13.8331C40.6457 13.6775 40.542 13.5219 40.4382 13.4181C32.9169 5.79307 33.28 6.00055 32.9169 6.00055H19.6379C18.4967 6.00055 17.6149 6.93423 17.6149 8.02353V23.5849L17.3555 22.7031C17.3037 22.4956 17.0962 22.34 16.8887 22.34H15.0213C14.762 22.34 14.6064 22.4956 14.5026 22.7031L13.8802 24.6223C13.5689 24.7261 13.3096 24.8298 12.9983 24.9854L11.2347 24.1036C11.0272 23.948 10.7679 23.9999 10.6123 24.1555L9.31549 25.4523C9.15988 25.6079 9.10801 25.8672 9.21175 26.0747L10.0936 27.8902C9.93795 28.2014 9.8342 28.4608 9.73046 28.772L7.8631 29.3426C7.65561 29.4463 7.5 29.6538 7.5 29.8613V31.7287C7.5 31.9362 7.65561 32.1436 7.8631 32.1955L9.78233 32.818C9.88608 33.1292 9.98982 33.3886 10.1454 33.6998L9.26362 35.4634C9.10801 35.6709 9.15988 35.9302 9.31549 36.0859ZM33.4356 7.76417L38.934 13.2625H34.6805C34.0062 13.2625 33.4875 12.7438 33.4875 12.0695V7.76417H33.4356ZM18.6523 8.02353C18.6523 7.45295 19.1192 7.03798 19.6379 7.03798H32.3982V12.0695C32.3982 13.2625 33.4356 14.2999 34.6286 14.2999H39.6602V37.1751C39.6602 37.7457 39.1933 38.1607 38.6746 38.1607H19.6379C19.3785 38.1607 19.171 38.057 19.0154 37.9532L18.5486 36.7083C18.6523 36.6564 18.7561 36.6564 18.8079 36.6046L20.5715 37.4864C20.779 37.5901 21.0384 37.5382 21.194 37.3826L22.5427 36.0859C22.6983 35.9302 22.7501 35.6709 22.6464 35.4634L21.7646 33.6479C21.9202 33.3885 22.0239 33.0773 22.1277 32.7661L24.0469 32.1436C24.2544 32.0918 24.41 31.8843 24.41 31.6768V29.8613C24.41 29.6538 24.2544 29.4463 24.0469 29.3945L22.1277 28.772C22.0239 28.4608 21.9202 28.2014 21.7646 27.9421L22.6464 26.1785C22.7501 25.971 22.6983 25.7635 22.5427 25.556L21.194 24.1555C21.0384 23.9999 20.779 23.948 20.5715 24.0517L18.8079 24.9335C18.7561 24.9335 18.7042 24.8817 18.6523 24.8817V8.02353ZM8.53742 31.3137V30.2244L10.3529 29.602C10.5085 29.5501 10.6641 29.3945 10.6641 29.2389C10.7679 28.8758 10.9235 28.4608 11.131 28.0977C11.2347 27.9421 11.2347 27.7865 11.131 27.6308L10.301 25.9191L11.0791 25.141L12.7909 26.0228C12.9465 26.1266 13.154 26.0747 13.3096 26.0228C13.6727 25.8154 14.0358 25.6597 14.4507 25.556C14.6064 25.5041 14.762 25.4004 14.8138 25.2448L15.4363 23.4293H16.5256L17.0962 25.2448C17.148 25.4004 17.3037 25.556 17.4593 25.556C17.8742 25.6597 18.2373 25.8154 18.6004 26.0228C18.7561 26.1266 18.9117 26.1266 19.0673 26.0228L20.779 25.1929L21.5571 25.971L20.7272 27.6827C20.6753 27.8383 20.6753 27.9939 20.7272 28.1496C20.9346 28.5127 21.0903 28.8758 21.194 29.2907C21.2459 29.4463 21.3496 29.602 21.5052 29.6538L23.3207 30.2763V31.3656L21.5052 31.9362C21.3496 31.988 21.194 32.1436 21.194 32.2993C21.0903 32.7142 20.9346 33.0773 20.7272 33.4404C20.6234 33.596 20.6234 33.7516 20.7272 33.9073L21.5571 35.619L20.779 36.3971L19.0673 35.5671C18.9117 35.5153 18.7561 35.5153 18.6004 35.5671C18.2373 35.7746 17.8742 35.9302 17.4593 36.034C17.3037 36.0859 17.148 36.1896 17.0962 36.3452L16.4737 38.1607H15.3844L14.762 36.3452C14.7101 36.1896 14.5545 36.034 14.3989 35.9821C14.0358 35.8784 13.6208 35.7228 13.2577 35.5153C13.1021 35.4115 12.9465 35.4115 12.7909 35.5153L11.0791 36.3452L10.301 35.5671L11.131 33.8554C11.1829 33.6998 11.1829 33.4923 11.131 33.3885C10.9235 33.0255 10.7679 32.6624 10.6641 32.2474C10.6123 32.0918 10.5085 31.988 10.3529 31.9362L8.53742 31.3137Z"
        fill="#E88236"
      />
      <path
        d="M15.9032 34.0105C17.6668 34.0105 19.1192 32.5581 19.1192 30.7945C19.1192 29.0309 17.6668 27.5785 15.9032 27.5785C14.1395 27.5785 12.6871 29.0309 12.6871 30.7945C12.6871 32.5581 14.1395 34.0105 15.9032 34.0105ZM15.9032 28.6159C17.0962 28.6159 18.0817 29.6015 18.0817 30.7945C18.0817 31.9875 17.0962 32.9731 15.9032 32.9731C14.7101 32.9731 13.7246 31.9875 13.7246 30.7945C13.7246 29.5496 14.7101 28.6159 15.9032 28.6159Z"
        fill="#E88236"
      />
      <path
        d="M37.1704 24.2074H24.5657C24.2545 24.2074 24.047 24.4149 24.047 24.7261C24.047 25.0373 24.2545 25.2448 24.5657 25.2448H37.1704C37.4816 25.2448 37.6891 25.0373 37.6891 24.7261C37.6891 24.4149 37.4298 24.2074 37.1704 24.2074Z"
        fill="#E88236"
      />
      <path
        d="M30.427 13.2625H25.2399C24.9287 13.2625 24.7212 13.4699 24.7212 13.7812C24.7212 14.0924 24.9287 14.2999 25.2399 14.2999H30.427C30.7383 14.2999 30.9457 14.0924 30.9457 13.7812C30.9457 13.4699 30.6864 13.2625 30.427 13.2625Z"
        fill="#E88236"
      />
      <path
        d="M21.1421 14.2999H22.7501C23.0614 14.2999 23.2688 14.0924 23.2688 13.7812C23.2688 13.4699 23.0614 13.2625 22.7501 13.2625H21.1421C20.8309 13.2625 20.6234 13.4699 20.6234 13.7812C20.6234 14.0924 20.8828 14.2999 21.1421 14.2999Z"
        fill="#E88236"
      />
      <path
        d="M26.0699 28.8757H29.5971C29.9083 28.8757 30.1158 28.6682 30.1158 28.357C30.1158 28.0457 29.9083 27.8383 29.5971 27.8383H26.0699C25.7586 27.8383 25.5511 28.0457 25.5511 28.357C25.5511 28.6682 25.8105 28.8757 26.0699 28.8757Z"
        fill="#E88236"
      />
      <path
        d="M37.1703 27.8383H32.9169C32.6057 27.8383 32.3982 28.0457 32.3982 28.357C32.3982 28.6682 32.6057 28.8757 32.9169 28.8757H37.1703C37.4816 28.8757 37.6891 28.6682 37.6891 28.357C37.6891 28.0457 37.4297 27.8383 37.1703 27.8383Z"
        fill="#E88236"
      />
      <path
        d="M30.3234 17.4641C30.3234 17.7754 30.5308 17.9829 30.8421 17.9829H37.1704C37.4816 17.9829 37.6891 17.7754 37.6891 17.4641C37.6891 17.1529 37.4816 16.9454 37.1704 16.9454H30.8421C30.5308 16.9454 30.3234 17.1529 30.3234 17.4641Z"
        fill="#E88236"
      />
      <path
        d="M21.1421 17.9829H28.1447C28.456 17.9829 28.6635 17.7754 28.6635 17.4641C28.6635 17.1529 28.456 16.9454 28.1447 16.9454H21.1421C20.8309 16.9454 20.6234 17.1529 20.6234 17.4641C20.6234 17.7754 20.8828 17.9829 21.1421 17.9829Z"
        fill="#E88236"
      />
      <path
        d="M26.0699 32.5585H33.0725C33.3837 32.5585 33.5912 32.3511 33.5912 32.0398C33.5912 31.7286 33.3837 31.5211 33.0725 31.5211H26.0699C25.7586 31.5211 25.5511 31.7286 25.5511 32.0398C25.5511 32.3511 25.8105 32.5585 26.0699 32.5585Z"
        fill="#E88236"
      />
      <path
        d="M37.1703 31.5211H35.3548C35.0435 31.5211 34.8361 31.7286 34.8361 32.0398C34.8361 32.3511 35.0435 32.5585 35.3548 32.5585H37.1703C37.4815 32.5585 37.689 32.3511 37.689 32.0398C37.689 31.7286 37.4296 31.5211 37.1703 31.5211Z"
        fill="#E88236"
      />
      <path
        d="M37.1703 20.5764H35.6142C35.3029 20.5764 35.0955 20.7839 35.0955 21.0951C35.0955 21.4064 35.3029 21.6138 35.6142 21.6138H37.1703C37.4815 21.6138 37.689 21.4064 37.689 21.0951C37.689 20.7839 37.4297 20.5764 37.1703 20.5764Z"
        fill="#E88236"
      />
      <path
        d="M26.7441 21.0951C26.7441 21.4064 26.9516 21.6138 27.2629 21.6138H32.9168C33.228 21.6138 33.4355 21.4064 33.4355 21.0951C33.4355 20.7839 33.228 20.5764 32.9168 20.5764H27.2629C27.0035 20.5764 26.7441 20.7839 26.7441 21.0951Z"
        fill="#E88236"
      />
      <path
        d="M25.4474 21.0951C25.4474 20.7839 25.24 20.5764 24.9287 20.5764H21.194C20.8828 20.5764 20.6753 20.7839 20.6753 21.0951C20.6753 21.4064 20.8828 21.6138 21.194 21.6138H24.9287C25.1881 21.6138 25.4474 21.3545 25.4474 21.0951Z"
        fill="#E88236"
      />
      <path
        d="M26.3293 35.1522H24.5657C24.2545 35.1522 24.047 35.3597 24.047 35.6709C24.047 35.9822 24.2545 36.1896 24.5657 36.1896H26.3293C26.6406 36.1896 26.848 35.9822 26.848 35.6709C26.848 35.3597 26.5887 35.1522 26.3293 35.1522Z"
        fill="#E88236"
      />
      <path
        d="M37.1703 35.1522H30.427C30.1158 35.1522 29.9083 35.3597 29.9083 35.6709C29.9083 35.9822 30.1158 36.1896 30.427 36.1896H37.1703C37.4815 36.1896 37.689 35.9822 37.689 35.6709C37.689 35.3597 37.4297 35.1522 37.1703 35.1522Z"
        fill="#E88236"
      />
      <path
        d="M21.1421 10.6689H30.3752C30.6864 10.6689 30.8939 10.4614 30.8939 10.1502C30.8939 9.83895 30.6864 9.63147 30.3752 9.63147H21.1421C20.8309 9.63147 20.6234 9.83895 20.6234 10.1502C20.6234 10.4614 20.8828 10.6689 21.1421 10.6689Z"
        fill="#E88236"
      />
      <path
        d="M10.9234 6.00049C10.0416 6.00049 9.36731 6.67481 9.36731 7.50475V17.9827C9.36731 18.0346 9.36731 18.1384 9.41918 18.1902L11.5978 22.4955C11.7015 22.6511 11.8571 22.8068 12.0646 22.8068C12.2721 22.8068 12.4277 22.703 12.5315 22.4955C14.8657 17.8271 14.7619 18.1384 14.7619 17.9827V7.50475C14.7619 6.67481 14.0876 6.00049 13.2058 6.00049H10.9234ZM12.0646 21.1469L10.716 18.5015H13.3614L12.0646 21.1469ZM13.7245 17.464H10.4047V10.0983H13.7245V17.464ZM13.7245 7.50475V9.00902H10.4047V7.50475C10.4047 7.2454 10.6122 7.03791 10.9234 7.03791H13.2058C13.517 7.03791 13.7245 7.2454 13.7245 7.50475Z"
        fill="#E88236"
      />
    </svg>
  );
};

export const ContentManagementIcon = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9879 8.77478H32.9754H36.4629L38.0129 9.93728L38.4004 12.6498V23.8873V33.1873L36.0754 34.3497L34.1379 34.7372H31.4254L31.0379 33.1873L29.8754 32.4123V30.4748L31.8129 29.3123L30.2629 26.2123L28.3254 27.3748L26.3879 26.5998V24.6623L22.9004 24.2748V26.5998L21.3504 27.3748L19.0254 26.2123L17.4754 28.9248L18.6379 29.6998L19.4129 30.4748V32.4123L17.8629 33.5747L17.4754 34.7372H13.9879L11.2754 33.5747L10.8879 29.6998V19.6248V11.0998L11.6629 9.16228L13.2129 8.77478H13.9879Z"
        fill="#FCEBC5"
      />
      <path
        d="M19.0246 26.5998L20.9621 27.3748L22.8996 26.5998L23.2871 24.2748H25.9995L26.387 26.5998L27.937 27.3748L29.8745 26.5998L31.4245 28.9248L29.8745 30.4748V32.7998L31.812 33.9623L29.8745 36.2873L28.3245 35.5123L26.387 36.2873V38.6123H23.6746H23.2871L22.8996 36.6748L21.3496 35.5123L19.4121 36.2873L18.2496 35.1248L17.8621 33.5748L19.4121 32.4123V30.0873L17.8621 28.9248L19.0246 26.5998Z"
        fill="#F8D88B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5412 38.1916H25.8541V36.3076C25.8541 36.1307 25.9685 35.9749 26.1362 35.9215C26.7898 35.7152 27.4039 35.36 27.9129 34.8946C28.0429 34.7759 28.2351 34.7548 28.3874 34.8433L30.0209 35.786L31.177 33.7826L29.5452 32.8406C29.3926 32.7522 29.3147 32.576 29.3526 32.4033C29.4264 32.0685 29.4635 31.7231 29.4635 31.3771C29.4637 31.0317 29.4263 30.6863 29.3526 30.3508C29.3149 30.1788 29.3926 30.002 29.5449 29.9142L31.177 28.9715L30.0209 26.9688L28.3875 27.9116C28.2353 27.9999 28.0427 27.9789 27.9129 27.8596C27.4041 27.3949 26.7898 27.0397 26.1362 26.8326C25.9685 26.78 25.8541 26.6234 25.8541 26.4472V24.5632H23.5412V26.4472C23.5412 26.6234 23.4267 26.78 23.2589 26.8326C22.6056 27.0397 21.9919 27.3949 21.483 27.8596C21.3525 27.9789 21.1601 27.9999 21.0077 27.9116L19.3751 26.9688L18.2183 28.9715L19.8505 29.9142C20.0028 30.002 20.0805 30.1788 20.0432 30.3508C19.9696 30.6863 19.9317 31.0317 19.9317 31.3771C19.9317 31.7225 19.9696 32.0678 20.0432 32.4033C20.0813 32.576 20.0033 32.7522 19.8502 32.8406L18.2183 33.7826L19.3751 35.786L21.0079 34.8433C21.1601 34.7548 21.3524 34.7759 21.483 34.8953C21.9912 35.36 22.6054 35.7152 23.2589 35.9222C23.4269 35.9755 23.5411 36.1314 23.5411 36.3076L23.5412 38.1916ZM26.2584 39.0002H23.1369C22.9136 39.0002 22.7324 38.8192 22.7324 38.5959L22.7326 36.5947C22.1668 36.3813 21.6324 36.0724 21.1629 35.687L19.4291 36.6881C19.3359 36.7421 19.2255 36.7569 19.1223 36.7288C19.0185 36.7006 18.93 36.6333 18.8766 36.5406L17.3156 33.8367C17.2041 33.6437 17.2705 33.3965 17.4636 33.285L19.1976 32.284C19.1483 31.9843 19.1229 31.681 19.1229 31.3771C19.123 31.0738 19.1483 30.7699 19.1967 30.4709L17.4637 29.4699C17.3711 29.4165 17.3028 29.328 17.2754 29.2241C17.2476 29.121 17.2621 29.0107 17.3155 28.9174L18.8767 26.2142C18.9884 26.0211 19.2353 25.9545 19.429 26.0661L21.163 27.0678C21.6327 26.6824 22.1667 26.3735 22.7324 26.1602L22.7326 24.1588C22.7326 23.9357 22.9136 23.7545 23.1368 23.7545H26.2584C26.4818 23.7545 26.6628 23.9357 26.6628 24.1588V26.1602C27.2285 26.3735 27.7627 26.6824 28.2323 27.0678L29.9668 26.066C30.1598 25.9545 30.4069 26.0211 30.5185 26.2142L32.0798 28.9174C32.1332 29.0107 32.1478 29.121 32.1205 29.2241C32.0924 29.328 32.0242 29.4165 31.9315 29.4699L30.1987 30.4709C30.2477 30.7699 30.2722 31.0731 30.2722 31.3771C30.2723 31.681 30.2476 31.985 30.1984 32.284L31.9317 33.285C32.0245 33.3383 32.0923 33.4268 32.1205 33.53C32.148 33.6339 32.1331 33.744 32.0797 33.8367L30.5188 36.5406C30.4078 36.7337 30.1598 36.7996 29.9668 36.6881L28.2324 35.687C27.7629 36.0717 27.2285 36.3806 26.6628 36.5947V38.5959C26.6628 38.8192 26.4816 39.0002 26.2584 39.0002Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.698 29.3428C23.5763 29.3428 22.6636 30.2554 22.6636 31.3771C22.6637 32.4988 23.5762 33.412 24.6979 33.412C25.8197 33.412 26.7321 32.4988 26.7321 31.3771C26.7322 30.2554 25.8197 29.3428 24.698 29.3428ZM24.698 34.2201C23.1306 34.2201 21.855 32.9453 21.855 31.3771C21.8551 29.8097 23.1305 28.5342 24.6979 28.5342C26.2654 28.5342 27.5408 29.8097 27.5408 31.3771C27.5409 32.9453 26.2654 34.2201 24.698 34.2201Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.1368 35.1609H31.0815C30.8585 35.1609 30.6771 34.9798 30.6771 34.7566C30.6772 34.5333 30.8582 34.3523 31.0814 34.3523H35.1368C36.7633 34.3523 38.0862 33.0291 38.0862 31.4026L38.0865 11.7577C38.0865 10.1313 36.7631 8.80875 35.1367 8.80875H14.2583C12.6318 8.80875 11.3086 10.1313 11.3086 11.7577L11.3089 31.4025C11.3089 33.029 12.6318 34.3522 14.2583 34.3522H18.3136C18.5369 34.3522 18.7178 34.5332 18.7178 34.7565C18.7179 34.9797 18.5367 35.1608 18.3135 35.1608H14.2583C12.1861 35.1608 10.5 33.4747 10.5 31.4025L10.5003 11.7576C10.5003 9.68545 12.1861 8 14.2583 8H35.1367C37.2089 8 38.8948 9.68545 38.8948 11.7576L38.895 31.4024C38.895 33.4746 37.2088 35.1609 35.1368 35.1609Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.4908 13.518H10.9046C10.6813 13.518 10.5 13.3369 10.5 13.1137C10.5003 12.8905 10.6811 12.7094 10.9043 12.7094H38.4906C38.7137 12.7094 38.8948 12.8905 38.8948 13.1137C38.895 13.3369 38.7137 13.518 38.4908 13.518Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9016 10.3336C14.6672 10.3336 14.4761 10.5245 14.4761 10.7589C14.4761 10.9934 14.6671 11.1843 14.9016 11.1843C15.136 11.1843 15.3269 10.9934 15.3269 10.7589C15.3271 10.5244 15.1359 10.3336 14.9016 10.3336ZM14.9016 11.993C14.2215 11.993 13.6675 11.4391 13.6675 10.7589C13.6675 10.0788 14.2213 9.5249 14.9016 9.5249C15.5817 9.5249 16.1356 10.0788 16.1356 10.7589C16.1357 11.4391 15.5817 11.993 14.9016 11.993Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6308 10.3336C18.3965 10.3336 18.2054 10.5245 18.2054 10.7589C18.2057 10.9934 18.3963 11.1843 18.6307 11.1843C18.8655 11.1843 19.0562 10.9934 19.0562 10.7589C19.0563 10.5244 18.8652 10.3336 18.6308 10.3336ZM18.6308 11.993C17.9507 11.993 17.3967 11.4391 17.3967 10.7589C17.397 10.0788 17.9507 9.5249 18.6307 9.5249C19.3112 9.5249 19.8648 10.0788 19.8648 10.7589C19.865 11.4391 19.311 11.993 18.6308 11.993Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3583 10.3336C22.1236 10.3336 21.9327 10.5245 21.9327 10.7589C21.9328 10.9934 22.1236 11.1843 22.358 11.1843C22.5927 11.1843 22.7835 10.9934 22.7835 10.7589C22.7835 10.5244 22.5925 10.3336 22.3583 10.3336ZM22.3583 11.993C21.6779 11.993 21.124 11.4391 21.124 10.7589C21.1242 10.0788 21.6778 9.5249 22.358 9.5249C23.0385 9.5249 23.5921 10.0788 23.5921 10.7589C23.5922 11.4391 23.0382 11.993 22.3583 11.993Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0685 16.0953H13.3272C13.1039 16.0953 12.9226 15.9149 12.9226 15.6909C12.9226 15.4678 13.1037 15.2866 13.3269 15.2866H36.0684C36.2917 15.2866 36.4725 15.4678 36.4725 15.6909C36.4727 15.9148 36.2915 16.0953 36.0685 16.0953Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0685 19.0403H13.3272C13.1039 19.0403 12.9226 18.8593 12.9226 18.636C12.9226 18.4128 13.1037 18.2317 13.3269 18.2317H36.0684C36.2917 18.2317 36.4725 18.4128 36.4725 18.636C36.4727 18.8593 36.2915 19.0403 36.0685 19.0403Z"
        fill="#E88236"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0685 21.9843H13.3272C13.1039 21.9843 12.9226 21.8032 12.9226 21.58C12.9226 21.3568 13.1037 21.1757 13.3269 21.1757H36.0684C36.2917 21.1757 36.4725 21.3568 36.4725 21.58C36.4727 21.8032 36.2915 21.9843 36.0685 21.9843Z"
        fill="#E88236"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="47"
      height="48"
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.1209 35.694C37.1209 34.9067 36.0898 34.2616 34.8289 34.2616H29.4358C29.2962 33.5479 30.6892 33.0819 30.9762 32.3543H32.5355C33.6822 32.3543 34.6193 31.7689 34.6193 31.0527C34.6193 30.3365 33.6809 29.7511 32.5355 29.7511H24.0746C22.9279 29.7511 21.9908 30.3365 21.9908 31.0527C21.9908 31.7689 22.9292 32.3543 24.0746 32.3543H24.9876C25.1069 32.6768 25.1717 32.9473 25.1882 33.2127L21.7927 33.2584C21.6022 33.9098 21.3025 34.2044 20.9584 34.3225H19.8358C19.6403 34.2921 19.4498 34.2628 19.2758 34.2628H15.5311C14.2701 34.2628 13.239 34.9079 13.239 35.6952C13.239 35.7054 13.2416 35.7155 13.2416 35.7257C13.2416 35.7359 13.239 35.746 13.239 35.7562C13.239 36.5435 14.2701 37.1886 15.5311 37.1886H20.9355C21.3139 37.9022 23.2644 38.3682 22.9774 39.0959H17.8244C16.6777 39.0959 15.7406 39.6813 15.7406 40.3974C15.7406 41.1136 16.679 41.699 17.8244 41.699H26.2854C27.432 41.699 28.3692 41.1136 28.3692 40.3974C28.3692 39.6813 27.4308 39.0959 26.2854 39.0959H25.3723C25.2517 38.7695 25.1869 38.4952 25.1717 38.2273L25.3914 38.2235C25.5933 37.5327 26.4657 37.2381 27.4777 37.1276H30.1177C30.5558 37.1568 30.905 37.1873 31.0866 37.1873H34.8314C36.0923 37.1873 37.1235 36.5422 37.1235 35.7549C37.1235 35.7448 37.1209 35.7346 37.1209 35.7244C37.1209 35.7143 37.1235 35.7041 37.1235 35.694H37.1209Z"
        fill="#FCEBC5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5248 40.9752C23.4562 41.0565 23.3546 41.1035 23.2479 41.1035C23.1413 41.1035 23.041 41.0565 22.9711 40.9752C18.6168 35.8806 11.1654 28.3048 11.1654 21.9327C11.1654 15.5606 16.5762 9.85016 23.2479 9.85016C29.9197 9.85016 35.3305 15.261 35.3305 21.9327C35.3305 28.6044 27.8816 35.8806 23.5248 40.9752Z"
        fill="#F8D88B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.248 31.8603C28.7146 31.8603 33.1756 27.4006 33.1756 21.9327C33.1756 16.4648 28.7159 12.0076 23.248 12.0076C17.78 12.0076 13.3229 16.4648 13.3229 21.9327C13.3229 27.4006 17.78 31.8603 23.248 31.8603Z"
        fill="#FCEBC5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6866 15.9048C25.3254 16.0572 25.9349 16.3099 26.4924 16.654L27.6657 16.1334L29.0485 17.5162L28.5279 18.6895C28.872 19.2483 29.1247 19.8578 29.2771 20.4953L30.4746 20.9562V22.913L29.2771 23.374C29.1247 24.0115 28.872 24.621 28.5279 25.1797L29.0485 26.353L27.6657 27.7372L26.4924 27.2153C25.9336 27.5594 25.3241 27.8134 24.6866 27.9645L24.2257 29.1607H22.2689L21.8079 27.9632C21.1704 27.8108 20.5609 27.5581 20.0022 27.214L18.8289 27.7359L17.4447 26.3518L17.9666 25.1784C17.6225 24.6197 17.3685 24.0102 17.2174 23.3727L16.0212 22.9118V20.9549L17.2174 20.494C17.3698 19.8553 17.6225 19.2457 17.9666 18.6883L17.4447 17.5149L18.8289 16.1321L20.0022 16.6527C20.5609 16.3086 21.1704 16.0559 21.8079 15.9035L22.2689 14.7061H24.2257L24.6866 15.9035V15.9048Z"
        fill="#FFE177"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9915 16.6997L27.3585 16.5371L28.6448 17.8235L28.161 18.9156C28.481 19.4349 28.7159 20.0013 28.8569 20.5956L29.9705 21.0248V22.8444L28.8569 23.2736C28.7159 23.8667 28.481 24.4343 28.161 24.9536L28.6448 26.0457L27.3585 27.3333L26.9915 27.1708L28.1153 26.047L27.6302 24.9549C27.9502 24.4356 28.1851 23.8692 28.3261 23.2749L29.4397 22.8457V21.026L28.3261 20.5968C28.1851 20.0025 27.9502 19.4362 27.6302 18.9168L28.1153 17.8248L26.9915 16.701V16.6997ZM18.975 16.6997L19.1375 16.5371L20.2283 17.0209C20.1508 17.0641 20.0747 17.1086 20.001 17.1556L18.975 16.6997ZM24.5864 16.3251C25.1807 16.466 25.747 16.7009 26.2664 17.0209L25.9654 17.1556C25.4461 16.8356 24.6499 16.466 24.0569 16.3251L23.6277 15.2114H24.1572L24.5864 16.3251ZM20.2296 26.847L19.1375 27.3321L18.975 27.1695L20.001 26.7136C20.0759 26.7594 20.1521 26.8038 20.2296 26.847ZM26.2664 26.847C25.747 27.167 25.1807 27.4032 24.5864 27.5441L24.1572 28.6578H23.6277L24.0569 27.5441C24.6512 27.4032 25.4461 27.0336 25.9667 26.7136L26.2664 26.847Z"
        fill="#FFD064"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.248 17.92C25.4651 17.92 27.2619 19.7168 27.2619 21.934C27.2619 24.1511 25.4651 25.9479 23.248 25.9479C21.0308 25.9479 19.234 24.1511 19.234 21.934C19.234 19.7168 21.0308 17.92 23.248 17.92Z"
        fill="#FCEBC5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1667 37.4908C17.2632 35.2876 15.2695 32.8673 13.6898 30.4089C11.8549 27.5517 10.5851 24.6336 10.5851 21.9327C10.5851 14.9409 16.2562 9.26984 23.2479 9.26984C30.2397 9.26984 35.9108 14.9409 35.9108 21.9327C35.9108 24.6336 34.641 27.5517 32.8073 30.4089C31.2289 32.8686 29.234 35.2889 27.3305 37.4908L26.3895 38.5727C25.4181 39.6825 24.4962 40.7251 23.6924 41.6749C23.5819 41.8057 23.4194 41.8806 23.2492 41.8806C23.0778 41.8806 22.9165 41.8057 22.806 41.6749C22.0035 40.7251 21.0803 39.6825 20.1089 38.5727L19.1679 37.4908H19.1667ZM23.2479 40.8229C25.8714 37.7714 29.5083 33.8895 32.0683 29.9022C33.8181 27.1771 35.0689 24.4114 35.0689 21.8349C35.0689 15.3067 29.7762 10.0127 23.2467 10.0127C16.7171 10.0127 11.4244 15.3067 11.4244 21.8349C11.4244 24.4102 12.6765 27.1771 14.4264 29.9022C16.9864 33.8895 20.6244 37.7714 23.2467 40.8229H23.2479ZM23.2479 32.4406C17.4613 32.4406 12.7425 27.7194 12.7425 21.9327C12.7425 16.146 17.4613 11.4273 23.2479 11.4273C29.0346 11.4273 33.7559 16.146 33.7559 21.9327C33.7559 27.7194 29.0346 32.4406 23.2479 32.4406ZM23.2479 31.6254C28.5864 31.6254 32.9406 27.2711 32.9406 21.9327C32.9406 16.5943 28.5864 12.2425 23.2479 12.2425C17.9095 12.2425 13.5578 16.5943 13.5578 21.9327C13.5578 27.2711 17.9095 31.6254 23.2479 31.6254ZM24.9648 15.9035C25.4295 16.0356 25.8765 16.2209 26.2994 16.4571L27.1552 16.0762C27.3457 15.9911 27.5679 16.033 27.7152 16.1803L29.0016 17.4667C29.1489 17.614 29.1895 17.8362 29.1057 18.0267L28.726 18.8825C28.9622 19.3054 29.1476 19.7536 29.2797 20.2197L30.1521 20.5562C30.3464 20.6311 30.4746 20.8178 30.4746 21.026V22.8457C30.4746 23.054 30.3464 23.2406 30.1521 23.3156L29.2784 23.6521C29.1464 24.1168 28.9597 24.5638 28.7248 24.9867L29.1044 25.8438C29.1883 26.0343 29.1476 26.2565 29.0003 26.4038L27.714 27.6902C27.5667 27.8375 27.3444 27.8781 27.154 27.7943L26.2981 27.4146C25.8765 27.6508 25.4283 27.8362 24.9622 27.9683L24.6257 28.8406C24.5508 29.0349 24.3641 29.1632 24.1559 29.1632H22.3362C22.1279 29.1632 21.9413 29.0349 21.8664 28.8406L21.5298 27.9683C21.0638 27.8362 20.6156 27.6495 20.1927 27.4146L19.3356 27.7943C19.1451 27.8781 18.9229 27.8375 18.7756 27.6902L17.4892 26.4038C17.3419 26.2565 17.3 26.0343 17.3851 25.8438L17.766 24.9879C17.5298 24.5663 17.3444 24.1181 17.2124 23.6533L16.3387 23.3168C16.1444 23.2419 16.0162 23.0552 16.0162 22.847V21.0273C16.0162 20.819 16.1444 20.6324 16.3387 20.5575L17.2124 20.2209C17.3457 19.7549 17.5311 19.3067 17.7673 18.8838L17.3864 18.0279C17.3013 17.8375 17.3432 17.6152 17.4905 17.4679L18.7768 16.1816C18.9241 16.0343 19.1464 15.9936 19.3368 16.0775L20.1927 16.4584C20.6156 16.2222 21.0625 16.0368 21.5273 15.9048L21.8651 15.0298C21.94 14.8356 22.1267 14.7073 22.3349 14.7073H24.1546C24.3629 14.7073 24.5495 14.8356 24.6244 15.0298L24.961 15.9048L24.9648 15.9035ZM24.1838 16.099L23.8562 15.247H22.6435L22.3146 16.1003C22.2498 16.2667 22.1089 16.3911 21.9349 16.4317C21.3533 16.5702 20.7971 16.8 20.2879 17.1149C20.1356 17.2089 19.9476 17.2216 19.7851 17.1492L18.9508 16.7784L18.0937 17.6356L18.4644 18.4698C18.5368 18.6324 18.5241 18.8216 18.4302 18.9727C18.1152 19.4832 17.8854 20.0394 17.7457 20.6235C17.7038 20.7962 17.5806 20.9384 17.4143 21.0019L16.5635 21.3295V22.5422L17.4143 22.8698C17.5806 22.9333 17.7038 23.0756 17.7457 23.2483C17.8854 23.8311 18.1152 24.3873 18.4302 24.8965C18.5241 25.0489 18.5368 25.2368 18.4644 25.4006L18.0937 26.2349L18.9508 27.0921L19.7851 26.7225C19.9476 26.6502 20.1356 26.6629 20.2867 26.7556C20.7971 27.0679 21.3521 27.3003 21.9362 27.4387C22.1102 27.4794 22.2524 27.6038 22.3159 27.7702L22.6435 28.6209H23.8562L24.1838 27.7702C24.2473 27.6038 24.3895 27.4794 24.5635 27.4387C25.1451 27.3003 25.7025 27.0705 26.2105 26.7568C26.3629 26.6629 26.5508 26.6502 26.7146 26.7225L27.5489 27.0921L28.4073 26.2336L28.0378 25.3994C27.9654 25.2368 27.9781 25.0489 28.0708 24.8978C28.3832 24.3873 28.6156 23.8311 28.754 23.2495C28.7946 23.0756 28.9191 22.9333 29.0854 22.8698L29.9362 22.5422V21.3295L29.0854 21.0019C28.9191 20.9384 28.7946 20.7962 28.754 20.6222C28.6156 20.0381 28.3857 19.4832 28.0708 18.9727C27.9768 18.8216 27.9641 18.6324 28.0365 18.4698L28.406 17.6356L27.5489 16.7784L26.7146 17.1492C26.5521 17.2216 26.3629 17.2089 26.2117 17.1149C25.7013 16.8 25.1464 16.5702 24.5648 16.4317C24.3908 16.3898 24.2486 16.2667 24.1851 16.099H24.1838ZM23.2492 17.6863C25.5959 17.6863 27.4994 19.5873 27.4994 21.934C27.4994 24.2806 25.5959 26.1841 23.2492 26.1841C20.9025 26.1841 19.0016 24.2806 19.0016 21.934C19.0016 19.5873 20.9025 17.6863 23.2492 17.6863ZM23.2492 18.4076C21.3 18.4076 19.7229 19.986 19.7229 21.934C19.7229 23.8819 21.3013 25.4629 23.2492 25.4629C25.1971 25.4629 26.7781 23.8832 26.7781 21.934C26.7781 19.9848 25.1971 18.4076 23.2492 18.4076Z"
        fill="#E88236"
      />
      <path
        d="M23.2492 41.9441C23.0588 41.9441 22.8797 41.8603 22.7578 41.7156C22.1369 40.9816 21.4461 40.1943 20.7146 39.3587C20.5 39.1137 20.2816 38.866 20.0619 38.6133L19.121 37.5314C17.3305 35.4603 15.2797 32.9968 13.6391 30.4419C11.5439 27.1784 10.5242 24.3937 10.5242 21.9314C10.5242 14.9143 16.2334 9.20508 23.2505 9.20508C30.2677 9.20508 35.9769 14.9143 35.9769 21.9314C35.9769 24.3937 34.9585 27.1784 32.8632 30.4419C31.2226 32.9981 29.1705 35.4603 27.3813 37.5314L26.4404 38.6133C26.2181 38.8673 25.9985 39.1175 25.7826 39.3638C25.0524 40.1968 24.3629 40.9829 23.7432 41.7143C23.62 41.859 23.441 41.9429 23.2518 41.9429L23.2492 41.9441ZM19.215 37.4489L20.1559 38.5308C20.3756 38.7822 20.594 39.0311 20.8086 39.2762C21.54 40.1105 22.2321 40.899 22.8531 41.6343C22.9521 41.7511 23.0956 41.8171 23.248 41.8171C23.4004 41.8171 23.5439 41.7498 23.6429 41.6343C24.2626 40.9016 24.9534 40.1143 25.6835 39.2813C25.8994 39.0349 26.1191 38.7848 26.3413 38.5308L27.2823 37.4489C29.0689 35.3803 31.1172 32.9232 32.7527 30.3733C34.8353 27.1302 35.8473 24.3695 35.8473 21.9314C35.8473 14.9841 30.1953 9.33206 23.248 9.33206C16.3007 9.33206 10.6486 14.9841 10.6486 21.9314C10.6486 24.3695 11.6607 27.1302 13.7432 30.3733C15.38 32.9219 17.427 35.3803 19.215 37.4489ZM23.248 40.9194L23.1997 40.8635C22.6842 40.2641 22.1343 39.6381 21.5527 38.974C19.154 36.2413 16.434 33.1429 14.3743 29.9365C12.3477 26.781 11.3623 24.1308 11.3623 21.8349C11.3623 15.2813 16.6943 9.94921 23.248 9.94921C29.8016 9.94921 35.1337 15.2813 35.1337 21.8349C35.1337 24.1308 34.1483 26.7797 32.1229 29.9365C30.0619 33.1467 27.3394 36.2476 24.9381 38.9816C24.3578 39.6419 23.8105 40.2667 23.2975 40.8635L23.2492 40.9194H23.248ZM23.248 10.0762C16.7642 10.0762 11.4892 15.3511 11.4892 21.8349C11.4892 24.1054 12.4683 26.7327 14.481 29.8679C16.5356 33.0679 19.2518 36.1613 21.648 38.8914C22.2131 39.534 22.7464 40.1422 23.248 40.7263C23.7483 40.146 24.2791 39.5403 24.8416 38.9003C27.2404 36.1689 29.9591 33.0717 32.015 29.8692C34.0277 26.734 35.0067 24.1067 35.0067 21.8362C35.0067 15.3524 29.7318 10.0775 23.248 10.0775V10.0762ZM23.248 32.5029C17.4207 32.5029 12.6791 27.76 12.6791 21.9314C12.6791 16.1029 17.4207 11.3625 23.248 11.3625C29.0753 11.3625 33.8194 16.1041 33.8194 21.9314C33.8194 27.7587 29.0765 32.5029 23.248 32.5029ZM23.248 11.4895C17.4905 11.4895 12.8061 16.174 12.8061 21.9314C12.8061 27.6889 17.4905 32.3759 23.248 32.3759C29.0054 32.3759 33.6924 27.6902 33.6924 21.9314C33.6924 16.1727 29.0067 11.4895 23.248 11.4895ZM23.248 31.6876C17.8702 31.6876 13.4943 27.3105 13.4943 21.9314C13.4943 16.5524 17.8702 12.1778 23.248 12.1778C28.6258 12.1778 33.0042 16.5537 33.0042 21.9314C33.0042 27.3092 28.627 31.6876 23.248 31.6876ZM23.248 12.3048C17.94 12.3048 13.6213 16.6235 13.6213 21.9314C13.6213 27.2394 17.94 31.5606 23.248 31.5606C28.5559 31.5606 32.8772 27.2406 32.8772 21.9314C32.8772 16.6222 28.5572 12.3048 23.248 12.3048ZM24.1585 29.2241H22.3388C22.1064 29.2241 21.8931 29.0781 21.8105 28.861L21.4854 28.0178C21.0397 27.8883 20.6054 27.7092 20.194 27.4832L19.3661 27.8502C19.154 27.9441 18.9 27.8971 18.7362 27.7333L17.4499 26.447C17.2848 26.2819 17.2378 26.0292 17.3331 25.8159L17.7 24.9892C17.4753 24.5829 17.295 24.1486 17.1642 23.699L16.3197 23.374C16.1026 23.2902 15.9566 23.0781 15.9566 22.8457V21.026C15.9566 20.7936 16.1026 20.5803 16.3197 20.4978L17.1642 20.1727C17.295 19.7232 17.4753 19.2889 17.7 18.8813L17.3318 18.0546C17.2366 17.8425 17.2835 17.5886 17.4486 17.4235L18.735 16.1371C18.8988 15.9721 19.1527 15.9251 19.3661 16.0203C19.8613 16.24 20.0848 16.3403 20.1839 16.3937C20.5953 16.1663 21.0321 15.9848 21.4829 15.854L21.8092 15.0083C21.8931 14.7911 22.1051 14.6451 22.3375 14.6451H24.1572C24.3896 14.6451 24.6029 14.7911 24.6867 15.0083L25.0118 15.854C25.46 15.9835 25.8931 16.1638 26.3019 16.3886L27.1286 16.0203C27.3419 15.9263 27.5946 15.9733 27.7597 16.1371L29.0461 17.4235C29.2099 17.5873 29.2581 17.8413 29.1629 18.0533C28.9432 18.5486 28.8442 18.7721 28.7908 18.8711C29.0194 19.2825 29.201 19.7206 29.3305 20.1727L30.1737 20.4978C30.3908 20.5816 30.5369 20.7936 30.5369 21.026V22.8457C30.5369 23.0781 30.3908 23.2914 30.1737 23.374L29.3305 23.699C29.201 24.1448 29.0219 24.5778 28.7959 24.9892L29.1629 25.8171C29.2569 26.0292 29.2099 26.2832 29.0461 26.447L27.7597 27.7333C27.5959 27.8971 27.3419 27.9454 27.1299 27.8502L26.3032 27.4844C25.8956 27.7092 25.4626 27.8895 25.0118 28.019L24.6867 28.8622C24.6029 29.0794 24.3908 29.2254 24.1572 29.2254L24.1585 29.2241ZM20.2004 27.341L20.2283 27.3562C20.6486 27.5898 21.0943 27.774 21.5515 27.9048L21.5819 27.9137L21.9299 28.8165C21.9946 28.9854 22.1597 29.0984 22.34 29.0984H24.1597C24.34 29.0984 24.5051 28.9854 24.5699 28.8165L24.9178 27.9137L24.9483 27.9048C25.4092 27.774 25.8537 27.5898 26.2702 27.3575L26.2981 27.3422L27.1832 27.7346C27.3483 27.8083 27.5451 27.7714 27.6721 27.6432L28.9585 26.3568C29.0854 26.2298 29.1223 26.033 29.0499 25.8679L28.6575 24.9829L28.6727 24.9549C28.9064 24.5346 29.0905 24.0902 29.2213 23.6343L29.2302 23.6038L30.1331 23.2559C30.3019 23.1911 30.415 23.026 30.415 22.8457V21.026C30.415 20.8457 30.3019 20.6806 30.1331 20.6159L29.2302 20.2679L29.2213 20.2375C29.0905 19.7765 28.9064 19.3321 28.674 18.9143L28.6588 18.8863L28.6715 18.8571C28.6765 18.8457 29.0512 18.0013 29.0512 18.0013C29.1248 17.8362 29.088 17.6394 28.9597 17.5124L27.6734 16.226C27.5451 16.0978 27.3496 16.061 27.1845 16.1346L26.2994 16.5283L26.2715 16.513C25.8537 16.2806 25.4092 16.0965 24.9508 15.9657L24.9204 15.9568L24.5724 15.0527C24.5077 14.8838 24.3426 14.7708 24.1623 14.7708H22.3426C22.1623 14.7708 21.9972 14.8838 21.9324 15.0514L21.5832 15.9568L21.5527 15.9657C21.0931 16.0965 20.6486 16.2806 20.2308 16.513L20.2029 16.5283L20.1737 16.5156C20.1623 16.5105 19.3178 16.1346 19.3178 16.1346C19.1527 16.061 18.9559 16.0978 18.8289 16.226L17.5426 17.5124C17.4143 17.6406 17.3788 17.8375 17.4524 18.0025L17.8461 18.8876L17.8308 18.9156C17.5985 19.3333 17.4131 19.7778 17.2823 20.2387L17.2734 20.2692L16.3705 20.6171C16.2016 20.6819 16.0886 20.847 16.0886 21.0273V22.847C16.0886 23.0273 16.2016 23.1924 16.3705 23.2571L17.2734 23.6051L17.2823 23.6356C17.4143 24.0965 17.5985 24.5422 17.8308 24.9575L17.8461 24.9854L17.4524 25.8705C17.3788 26.0356 17.4156 26.2324 17.5426 26.3606L18.8289 27.647C18.9559 27.774 19.1527 27.8108 19.3178 27.7384L20.2029 27.346L20.2004 27.341ZM23.8994 28.6844H22.5991L22.2562 27.793C22.1991 27.6457 22.0746 27.5365 21.921 27.4997C21.3356 27.3613 20.7743 27.1289 20.2524 26.8089C20.1191 26.7263 19.9527 26.7162 19.8092 26.7797L18.9343 27.167L18.015 26.2476L18.4035 25.374C18.467 25.2292 18.4569 25.0629 18.3731 24.9295C18.0569 24.4178 17.8232 23.8578 17.681 23.2635C17.6442 23.1111 17.535 22.9854 17.3889 22.9295L16.4975 22.5867V21.2863L17.3889 20.9435C17.535 20.8876 17.6454 20.7619 17.681 20.6095C17.8232 20.0165 18.0569 19.4552 18.3731 18.941C18.4556 18.8063 18.467 18.6413 18.4035 18.4965L18.015 17.6229L18.9343 16.7035L19.808 17.0921C19.9515 17.1556 20.1178 17.1454 20.2524 17.0629C20.768 16.7454 21.3292 16.513 21.9185 16.3721C22.0708 16.3352 22.1965 16.226 22.2537 16.08L22.5991 15.186H23.8994L24.2423 16.08C24.2981 16.2273 24.4239 16.3365 24.5775 16.3733C25.1667 16.513 25.728 16.7454 26.2435 17.0641C26.3781 17.1467 26.5432 17.1581 26.688 17.0933L27.5616 16.7048L28.481 17.6241L28.0937 18.499C28.0302 18.6425 28.0416 18.8089 28.1242 18.9422C28.4429 19.459 28.674 20.0203 28.815 20.6095C28.8518 20.7632 28.961 20.8889 29.1083 20.9448L29.9997 21.2876V22.5879L29.1083 22.9308C28.961 22.9879 28.8518 23.1124 28.815 23.266C28.6765 23.8502 28.4442 24.4114 28.1242 24.9333C28.0416 25.0667 28.0315 25.233 28.095 25.3765L28.4823 26.2514L27.5629 27.1708L26.688 26.7835C26.5432 26.72 26.3781 26.7314 26.2435 26.814C25.7305 27.1314 25.1705 27.3625 24.5788 27.5035C24.4251 27.5403 24.3007 27.6495 24.2435 27.7968L23.9007 28.6883L23.8994 28.6844ZM22.6867 28.5575H23.8131L24.1254 27.7473C24.1966 27.5619 24.3553 27.4222 24.5496 27.3765C25.1286 27.2394 25.6759 27.0121 26.1775 26.7022C26.3477 26.5968 26.5572 26.5829 26.74 26.6641L27.535 27.0159L28.3312 26.2197L27.9794 25.4248C27.8994 25.2432 27.9134 25.0336 28.0162 24.8648C28.3286 24.3543 28.5559 23.8057 28.6918 23.2343C28.7375 23.04 28.8772 22.8813 29.0626 22.8102L29.8727 22.4978V21.3714L29.0626 21.059C28.8759 20.9879 28.7375 20.8292 28.6918 20.6349C28.5546 20.0584 28.3273 19.5098 28.0162 19.0044C27.9121 18.8343 27.8969 18.6248 27.9781 18.4432L28.3299 17.6483L27.5337 16.8521L26.7388 17.2051C26.5572 17.2863 26.3464 17.2724 26.1762 17.167C25.6721 16.8559 25.1235 16.6286 24.547 16.4914C24.3527 16.4457 24.194 16.306 24.1229 16.1206L23.8105 15.3092H22.6842L22.3705 16.1219C22.2981 16.3073 22.1407 16.4457 21.9464 16.4927C21.3699 16.6298 20.8213 16.8571 20.3172 17.1683C20.147 17.2724 19.9362 17.2863 19.7546 17.2063L18.9597 16.8533L18.1648 17.6483L18.5178 18.4432C18.5991 18.626 18.5851 18.8356 18.4797 19.0057C18.1699 19.5098 17.9413 20.0584 17.8029 20.6375C17.7559 20.8305 17.6175 20.9892 17.4321 21.0603L16.6219 21.3727V22.499L17.4321 22.8114C17.6175 22.8825 17.7559 23.0413 17.8029 23.2343C17.9426 23.8159 18.1712 24.3644 18.4797 24.8635C18.5851 25.0336 18.5991 25.2444 18.5178 25.4273L18.1648 26.2222L18.961 27.0184L19.7559 26.6667C19.9375 26.5867 20.147 26.6006 20.3159 26.7035C20.8264 27.0159 21.375 27.2432 21.9477 27.379C22.1419 27.4248 22.3007 27.5632 22.3718 27.7498L22.6842 28.56L22.6867 28.5575ZM23.248 26.2463C20.8708 26.2463 18.9369 24.3111 18.9369 21.9327C18.9369 19.5543 20.8708 17.6216 23.248 17.6216C25.6251 17.6216 27.5616 19.5556 27.5616 21.9327C27.5616 24.3098 25.6264 26.2463 23.248 26.2463ZM23.248 17.7486C20.9407 17.7486 19.0639 19.6254 19.0639 21.9327C19.0639 24.24 20.9407 26.1194 23.248 26.1194C25.5553 26.1194 27.4346 24.2413 27.4346 21.9327C27.4346 19.6241 25.5566 17.7486 23.248 17.7486ZM23.248 25.5251C21.2683 25.5251 19.6581 23.9136 19.6581 21.9327C19.6581 19.9517 21.2683 18.3429 23.248 18.3429C25.2277 18.3429 26.8404 19.953 26.8404 21.9327C26.8404 23.9124 25.2289 25.5251 23.248 25.5251ZM23.248 18.4686C21.3381 18.4686 19.7851 20.0216 19.7851 21.9314C19.7851 23.8413 21.3381 25.3968 23.248 25.3968C25.1578 25.3968 26.7134 23.8425 26.7134 21.9314C26.7134 20.0203 25.1591 18.4686 23.248 18.4686Z"
        fill="#E88236"
      />
    </svg>
  );
};

export const AnalyticsIcon = () => {
  return (
    <svg
      width="47"
      height="48"
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.9387 28.5499H16.58C14.9977 28.5499 13.7038 29.0895 13.7038 29.7499C13.7038 30.4102 14.9977 30.9499 16.58 30.9499H22.9736C23.1616 31.7295 22.9977 31.548 22.4835 31.9734C20.9914 32.0153 16.8416 32.5372 16.8416 33.1695C16.8416 33.8019 18.1355 34.3695 19.7177 34.3695H20.4352V34.8978H4.3895C2.80727 34.8978 1.51331 35.4375 1.51331 36.0978C1.51331 36.7581 2.80727 37.2978 4.3895 37.2978H10.7831C10.9711 38.0775 10.8073 37.8959 10.293 38.3213C8.80092 38.3632 4.65108 38.8851 4.65108 39.5175C4.65108 40.1499 5.94505 40.7175 7.52727 40.7175H32.6308C34.213 40.7175 35.507 40.1778 35.507 39.5175C35.507 38.8572 34.213 38.3175 32.6308 38.3175H27.8066C27.3279 37.8895 27.1768 38.0749 27.352 37.2978H39.4295C41.0117 37.2978 42.3057 36.7581 42.3057 36.0978C42.3057 35.4375 41.0117 34.8978 39.4295 34.8978H38.8479V34.3695H41.7736C43.3558 34.3695 44.6498 33.8299 44.6498 33.1695C44.6498 32.5092 43.3558 31.9695 41.7736 31.9695H41.1857C41.0803 31.9695 40.9762 31.9353 40.8936 31.8692C40.6358 31.6661 40.5012 31.6407 40.4885 31.4311C40.472 31.167 40.6993 30.9499 40.9647 30.9499H41.1336C42.7158 30.9499 42.8136 30.4102 42.8136 29.7499C42.8136 29.0895 41.5197 28.5499 39.9374 28.5499H39.9387Z"
        fill="#FCEBC5"
      />
      <path
        d="M12.3387 27.9759C12.3387 28.8444 11.6352 29.5479 10.7666 29.5479C9.89807 29.5479 9.19458 28.8444 9.19458 27.9759C9.19458 27.1073 9.89807 26.4038 10.7666 26.4038C11.6352 26.4038 12.3387 27.1073 12.3387 27.9759Z"
        fill="#FCEBC5"
      />
      <path
        d="M18.9317 24.673C18.9317 25.5416 18.2282 26.2451 17.3597 26.2451C16.4911 26.2451 15.7876 25.5416 15.7876 24.673C15.7876 23.8044 16.4911 23.101 17.3597 23.101C18.2282 23.101 18.9317 23.8044 18.9317 24.673Z"
        fill="#FCEBC5"
      />
      <path
        d="M25.526 18.0686C25.526 18.9372 24.8225 19.6406 23.954 19.6406C23.0854 19.6406 22.3819 18.9372 22.3819 18.0686C22.3819 17.2 23.0854 16.4965 23.954 16.4965C24.8225 16.4965 25.526 17.2 25.526 18.0686Z"
        fill="#F8D88B"
      />
      <path
        d="M32.1203 21.3702C32.1203 22.2387 31.4168 22.9422 30.5483 22.9422C29.6797 22.9422 28.9762 22.2387 28.9762 21.3702C28.9762 20.5016 29.6797 19.7981 30.5483 19.7981C31.4168 19.7981 32.1203 20.5016 32.1203 21.3702Z"
        fill="#FCEBC5"
      />
      <path
        d="M38.7133 11.4629C38.7133 12.3314 38.0098 13.0349 37.1413 13.0349C36.2727 13.0349 35.5692 12.3314 35.5692 11.4629C35.5692 10.5943 36.2727 9.89081 37.1413 9.89081C38.0098 9.89081 38.7133 10.5943 38.7133 11.4629Z"
        fill="#FFE177"
      />
      <path
        d="M31.4194 19.2483L36.2714 11.9581L31.4194 19.2483Z"
        fill="#F8D88B"
      />
      <path
        d="M25.3597 17.9581L29.1425 19.8527L25.3597 17.9581Z"
        fill="#F8D88B"
      />
      <path
        d="M18.4708 22.7467L22.8441 18.3657L18.4708 22.7467Z"
        fill="#F8D88B"
      />
      <path
        d="M12.1724 26.4572L15.9552 24.5626L12.1724 26.4572Z"
        fill="#F8D88B"
      />
      <path
        d="M12.9317 32.1371H9.53111C9.29619 32.1371 9.10571 32.3086 9.10571 32.5194V40.941H13.3559V32.5194C13.3559 32.3086 13.1654 32.1371 12.9305 32.1371H12.9317Z"
        fill="#FCEBC5"
      />
      <path
        d="M19.5261 29.1644H16.1267C15.8918 29.1644 15.7013 29.3359 15.7013 29.5467V40.9397H19.9515V29.5467C19.9515 29.3359 19.761 29.1644 19.5261 29.1644Z"
        fill="#FCEBC5"
      />
      <path
        d="M26.1191 23.8451H22.7197C22.4848 23.8451 22.2943 24.0102 22.2943 24.2133V40.941H26.5445V24.2133C26.5445 24.0102 26.354 23.8451 26.1191 23.8451Z"
        fill="#F8D88B"
      />
      <path
        d="M29.827 26.5194H29.3127C29.0778 26.5194 28.8873 26.687 28.8873 26.894V40.941H33.1375V26.894C33.1375 26.687 32.947 26.5194 32.7121 26.5194H32.1978"
        fill="#FCEBC5"
      />
      <path
        d="M39.733 28.72V18.3988C39.733 18.1943 39.5425 18.0292 39.3076 18.0292H35.907C35.672 18.0292 35.4816 18.1943 35.4816 18.3988V40.941H39.7317V30.7835"
        fill="#F8D88B"
      />
      <path
        d="M10.7667 30.2057C9.54764 30.2057 8.55463 29.2139 8.55463 27.9936C8.55463 26.7733 9.54637 25.7816 10.7667 25.7816C11.987 25.7816 12.9788 26.7733 12.9788 27.9936C12.9788 29.2139 11.987 30.2057 10.7667 30.2057ZM10.7667 27.0616C10.2524 27.0616 9.83463 27.4793 9.83463 27.9936C9.83463 28.5079 10.2524 28.9257 10.7667 28.9257C11.281 28.9257 11.6988 28.5079 11.6988 27.9936C11.6988 27.4793 11.281 27.0616 10.7667 27.0616Z"
        fill="#E88236"
      />
      <path
        d="M17.361 26.9028C16.1419 26.9028 15.1489 25.9111 15.1489 24.6908C15.1489 23.4704 16.1407 22.4787 17.361 22.4787C18.5813 22.4787 19.5731 23.4704 19.5731 24.6908C19.5731 25.9111 18.5813 26.9028 17.361 26.9028ZM17.361 23.7587C16.8467 23.7587 16.4289 24.1765 16.4289 24.6908C16.4289 25.205 16.8467 25.6228 17.361 25.6228C17.8753 25.6228 18.2931 25.205 18.2931 24.6908C18.2931 24.1765 17.8753 23.7587 17.361 23.7587Z"
        fill="#E88236"
      />
      <path
        d="M23.954 20.2984C22.735 20.2984 21.7419 19.3066 21.7419 18.0863C21.7419 16.866 22.7337 15.8743 23.954 15.8743C25.1743 15.8743 26.1661 16.866 26.1661 18.0863C26.1661 19.3066 25.1743 20.2984 23.954 20.2984ZM23.954 17.1543C23.4397 17.1543 23.0219 17.572 23.0219 18.0863C23.0219 18.6006 23.4397 19.0184 23.954 19.0184C24.4683 19.0184 24.8861 18.6006 24.8861 18.0863C24.8861 17.572 24.4683 17.1543 23.954 17.1543Z"
        fill="#E88236"
      />
      <path
        d="M30.5482 23.6C29.3292 23.6 28.3362 22.6082 28.3362 21.3879C28.3362 20.1676 29.3279 19.1758 30.5482 19.1758C31.7686 19.1758 32.7603 20.1676 32.7603 21.3879C32.7603 22.6082 31.7686 23.6 30.5482 23.6ZM30.5482 20.4558C30.034 20.4558 29.6162 20.8736 29.6162 21.3879C29.6162 21.9022 30.034 22.32 30.5482 22.32C31.0625 22.32 31.4803 21.9022 31.4803 21.3879C31.4803 20.8736 31.0625 20.4558 30.5482 20.4558Z"
        fill="#E88236"
      />
      <path
        d="M37.1425 13.6927C35.9235 13.6927 34.9305 12.7009 34.9305 11.4806C34.9305 10.2603 35.9222 9.26855 37.1425 9.26855C38.3629 9.26855 39.3533 10.2603 39.3533 11.4806C39.3533 12.7009 38.3616 13.6927 37.1425 13.6927ZM37.1425 10.5486C36.6283 10.5486 36.2105 10.9663 36.2105 11.4806C36.2105 11.9949 36.6283 12.4127 37.1425 12.4127C37.6568 12.4127 38.0746 11.9949 38.0746 11.4806C38.0746 10.9663 37.6568 10.5486 37.1425 10.5486Z"
        fill="#E88236"
      />
      <path
        d="M31.4181 20.72C31.2962 20.72 31.173 20.6857 31.0638 20.6133C30.7692 20.4178 30.6905 20.0203 30.8861 19.727L35.7381 12.4368C35.9337 12.1422 36.3311 12.0635 36.6245 12.259C36.9191 12.4546 36.9978 12.8521 36.8023 13.1454L31.9502 20.4356C31.827 20.621 31.6238 20.7213 31.4169 20.7213L31.4181 20.72Z"
        fill="#E88236"
      />
      <path
        d="M29.1425 21.3244C29.046 21.3244 28.9483 21.3028 28.8568 21.2571L25.074 19.3625C24.7578 19.2038 24.6308 18.8203 24.7883 18.5041C24.947 18.1879 25.3305 18.0609 25.6467 18.2184L29.4295 20.113C29.7457 20.2717 29.8727 20.6552 29.7152 20.9714C29.6035 21.1949 29.3775 21.3244 29.1425 21.3244Z"
        fill="#E88236"
      />
      <path
        d="M18.4708 24.2184C18.307 24.2184 18.1432 24.1562 18.0187 24.0317C17.7686 23.7816 17.7686 23.3765 18.0187 23.1276L22.3921 18.7466C22.6422 18.4965 23.0473 18.4965 23.2962 18.7466C23.5464 18.9968 23.5464 19.4019 23.2962 19.6508L18.9229 24.0317C18.7984 24.1574 18.6346 24.2197 18.4695 24.2197L18.4708 24.2184Z"
        fill="#E88236"
      />
      <path
        d="M12.1724 27.9302C11.9375 27.9302 11.7127 27.8006 11.5997 27.5772C11.441 27.261 11.5692 26.8775 11.8854 26.7187L15.6683 24.8241C15.9845 24.6667 16.368 24.7937 16.5267 25.1099C16.6854 25.426 16.5572 25.8095 16.241 25.9683L12.4581 27.8629C12.3667 27.9086 12.2689 27.9302 12.1724 27.9302Z"
        fill="#E88236"
      />
      <path
        d="M13.3571 41.4057H9.10698C8.75396 41.4057 8.46698 41.1568 8.46698 40.8508V32.7276C8.46698 32.2184 8.94444 31.8032 9.53238 31.8032H12.933C13.5197 31.8032 13.9971 32.2184 13.9971 32.7276V40.8508C13.9971 41.1568 13.7102 41.4057 13.3571 41.4057ZM9.74698 40.2946H12.7184V32.913H9.74698V40.2946Z"
        fill="#E88236"
      />
      <path
        d="M19.9514 41.4057H15.7013C15.3483 41.4057 15.0613 41.1568 15.0613 40.8508V29.8603C15.0613 29.3511 15.5387 28.9359 16.1267 28.9359H19.5273C20.114 28.9359 20.5927 29.3511 20.5927 29.8603V40.8508C20.5927 41.1568 20.3057 41.4057 19.9527 41.4057H19.9514ZM16.3413 40.2946H19.3127V30.0457H16.3413V40.2946Z"
        fill="#E88236"
      />
      <path
        d="M26.5445 41.4057H22.2943C21.9413 41.4057 21.6543 41.1568 21.6543 40.8508V24.1016C21.6543 23.5924 22.1318 23.1771 22.7197 23.1771H26.1203C26.707 23.1771 27.1857 23.5924 27.1857 24.1016V40.8508C27.1857 41.1568 26.8987 41.4057 26.5457 41.4057H26.5445ZM22.9343 40.2946H25.9057V24.287H22.9343V40.2946Z"
        fill="#E88236"
      />
      <path
        d="M40.8695 41.9873H7.96922C7.61621 41.9873 7.32922 41.7003 7.32922 41.3473C7.32922 40.9943 7.61621 40.7073 7.96922 40.7073H40.8695C41.2226 40.7073 41.5095 40.9943 41.5095 41.3473C41.5095 41.7003 41.2226 41.9873 40.8695 41.9873Z"
        fill="#E88236"
      />
      <path
        d="M33.1388 41.4057H28.8886C28.5356 41.4057 28.2486 41.1568 28.2486 40.8508V26.993C28.2486 26.4838 28.7261 26.0685 29.314 26.0685H29.8283C30.1813 26.0685 30.4683 26.3174 30.4683 26.6235C30.4683 26.9295 30.1813 27.1784 29.8283 27.1784H29.5286V40.2946H32.5V27.1784H32.2003C31.8473 27.1784 31.5603 26.9295 31.5603 26.6235C31.5603 26.3174 31.8473 26.0685 32.2003 26.0685H32.7146C33.3013 26.0685 33.7788 26.4838 33.7788 26.993V40.8508C33.7788 41.1568 33.4918 41.4057 33.1388 41.4057Z"
        fill="#E88236"
      />
      <path
        d="M39.7331 41.4057H35.4829C35.1299 41.4057 34.8429 41.1568 34.8429 40.8508V18.3518C34.8429 17.8425 35.3204 17.4273 35.9083 17.4273H39.3089C39.8956 17.4273 40.3743 17.8425 40.3743 18.3518V28.6527C40.3743 28.9587 40.0873 29.2076 39.7343 29.2076C39.3813 29.2076 39.0943 28.9587 39.0943 28.6527V18.5384H36.1229V40.2959H39.0943V30.7124C39.0943 30.4064 39.3813 30.1575 39.7343 30.1575C40.0873 30.1575 40.3743 30.4064 40.3743 30.7124V40.8508C40.3743 41.1568 40.0873 41.4057 39.7343 41.4057H39.7331Z"
        fill="#E88236"
      />
    </svg>
  );
};

export const SchedulesCalendarIcon = () => {
  return (
    <svg
      width="47"
      height="48"
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2050_8191)">
        <path
          d="M29.013 23.7943H21.1768C20.1317 23.7943 19.2771 24.3289 19.2771 24.9803C19.2771 25.6318 20.1317 26.1664 21.1768 26.1664H29.1514C29.267 26.9346 29.1679 26.7505 28.8517 27.1746H25.6657C24.6206 27.1746 23.766 27.7092 23.766 28.3607C23.766 29.0121 24.6206 29.5467 25.6657 29.5467H42.2422C43.2873 29.5467 44.1419 29.0121 44.1419 28.3607C44.1419 27.7092 41.4016 27.2203 40.4162 27.1784C40.0759 26.7569 39.9679 26.9372 40.0924 26.1664H44.3146C45.3597 26.1664 46.2143 25.6318 46.2143 24.9803C46.2143 24.3289 45.3597 23.7943 44.3146 23.7943H29.013Z"
          fill="#FCEBC5"
        />
        <path
          d="M18.3692 32.5397H26.2054C27.2505 32.5397 28.1051 33.0743 28.1051 33.7257C28.1051 34.3771 27.2505 34.9117 26.2054 34.9117H18.2308C18.1152 35.68 18.2143 35.4959 18.5305 35.92H21.7165C22.7616 35.92 23.6162 36.4546 23.6162 37.106C23.6162 37.7574 22.7616 38.2921 21.7165 38.2921H5.14C4.09492 38.2921 3.24032 37.7574 3.24032 37.106C3.24032 36.4546 5.98064 35.9657 6.96603 35.9238C7.30635 35.5022 7.41429 35.6825 7.28984 34.9117H3.06762C2.02254 34.9117 1.16794 34.3771 1.16794 33.7257C1.16794 33.0743 2.02254 32.5397 3.06762 32.5397H18.3692Z"
          fill="#FCEBC5"
        />
        <path
          d="M35.6403 18.7403H13.2073C11.7822 18.7403 10.627 19.8955 10.627 21.3206V36.5105C10.627 37.9355 11.7822 39.0908 13.2073 39.0908H35.6403C37.0654 39.0908 38.2206 37.9355 38.2206 36.5105V21.3206C38.2206 19.8955 37.0654 18.7403 35.6403 18.7403Z"
          fill="#FCEBC5"
        />
        <path
          d="M13.6111 12.4165H34.7756C36.4225 12.4165 37.7597 13.7536 37.7597 15.4006V18.7403H10.627V15.4006C10.627 13.7536 11.9641 12.4165 13.6111 12.4165Z"
          fill="#F8D88B"
        />
        <path
          d="M18.0111 10.1168H17.4994C16.7518 10.1168 16.1457 10.7229 16.1457 11.4705V13.1327C16.1457 13.8803 16.7518 14.4863 17.4994 14.4863H18.0111C18.7587 14.4863 19.3648 13.8803 19.3648 13.1327V11.4705C19.3648 10.7229 18.7587 10.1168 18.0111 10.1168Z"
          fill="#F8D88B"
        />
        <path
          d="M31.4625 10.1168H30.9508C30.2032 10.1168 29.5971 10.7229 29.5971 11.4705V13.1327C29.5971 13.8803 30.2032 14.4863 30.9508 14.4863H31.4625C32.2101 14.4863 32.8162 13.8803 32.8162 13.1327V11.4705C32.8162 10.7229 32.2101 10.1168 31.4625 10.1168Z"
          fill="#F8D88B"
        />
        <path
          d="M34.2562 41.1632C38.6696 41.1632 42.2473 37.5855 42.2473 33.1721C42.2473 28.7587 38.6696 25.181 34.2562 25.181C29.8428 25.181 26.2651 28.7587 26.2651 33.1721C26.2651 37.5855 29.8428 41.1632 34.2562 41.1632Z"
          fill="#F8D88B"
        />
        <path
          d="M28.5381 38.3987H13.8778C12.5698 38.3987 11.5095 37.3384 11.5095 36.0305V19.454H37.559V25.7079C37.559 26.1435 37.9121 26.4978 38.3489 26.4978C38.7857 26.4978 39.1387 26.1448 39.1387 25.7079V15.5073C39.1362 13.3283 37.3711 11.5632 35.1921 11.5606H33.6136C33.6136 10.2527 32.5533 9.19238 31.2454 9.19238C29.9375 9.19238 28.8771 10.2527 28.8771 11.5606H20.194C20.194 10.2527 19.1336 9.19238 17.8257 9.19238C16.5178 9.19238 15.4575 10.2527 15.4575 11.5606H13.879C11.7 11.5632 9.93491 13.3283 9.93237 15.5073V36.0305C9.93491 38.2095 11.7 39.9746 13.879 39.9771H28.5394C28.9749 39.9771 29.3292 39.6241 29.3292 39.1873C29.3292 38.7505 28.9762 38.3975 28.5394 38.3975L28.5381 38.3987ZM30.4555 11.5606C30.4555 11.1251 30.8086 10.7708 31.2454 10.7708C31.6822 10.7708 32.0352 11.1238 32.0352 11.5606V13.1391C32.0352 13.5746 31.6822 13.9289 31.2454 13.9289C30.8086 13.9289 30.4555 13.5759 30.4555 13.1391V11.5606ZM17.0359 11.5606C17.0359 11.1251 17.3889 10.7708 17.8257 10.7708C18.2625 10.7708 18.6155 11.1238 18.6155 11.5606V13.1391C18.6155 13.5746 18.2625 13.9289 17.8257 13.9289C17.3889 13.9289 17.0359 13.5759 17.0359 13.1391V11.5606ZM11.5108 15.5073C11.5108 14.1994 12.5711 13.1391 13.879 13.1391H15.4575C15.4575 14.447 16.5178 15.5073 17.8257 15.5073C19.1336 15.5073 20.194 14.447 20.194 13.1391H28.8771C28.8771 14.447 29.9375 15.5073 31.2454 15.5073C32.5533 15.5073 33.6136 14.447 33.6136 13.1391H35.1921C36.5 13.1391 37.5603 14.1994 37.5603 15.5073V17.8756H11.5108V15.5073Z"
          fill="#E88236"
        />
        <path
          d="M19.4041 23.4006C19.4041 22.5282 18.6968 21.8222 17.8257 21.8222H15.4575C14.5851 21.8222 13.8791 22.5295 13.8791 23.4006V25.7689C13.8791 26.6413 14.5864 27.3473 15.4575 27.3473H17.8257C18.6981 27.3473 19.4041 26.64 19.4041 25.7689V23.4006ZM15.4575 25.7689V23.4006H17.8257V25.7689H15.4575Z"
          fill="#E88236"
        />
        <path
          d="M27.2974 23.4006C27.2974 22.5282 26.5901 21.8222 25.719 21.8222H23.3508C22.4784 21.8222 21.7724 22.5295 21.7724 23.4006V25.7689C21.7724 26.6413 22.4797 27.3473 23.3508 27.3473H25.719C26.5914 27.3473 27.2974 26.64 27.2974 25.7689V23.4006ZM23.3508 25.7689V23.4006H25.719V25.7689H23.3508Z"
          fill="#E88236"
        />
        <path
          d="M34.4022 25.0908C34.8378 25.0908 35.1921 24.7378 35.1921 24.3009V23.4006C35.1921 22.5282 34.4848 21.8222 33.6137 21.8222H31.2454C30.373 21.8222 29.667 22.5295 29.667 23.4006V25.6736C29.667 26.1092 30.02 26.4635 30.4568 26.4635C30.8937 26.4635 31.2467 26.1105 31.2467 25.6736V23.4006H33.6149V24.3009C33.6149 24.7365 33.9679 25.0908 34.4048 25.0908H34.4022Z"
          fill="#E88236"
        />
        <path
          d="M17.8257 29.7156H15.4575C14.5851 29.7156 13.8791 30.4229 13.8791 31.294V33.6622C13.8791 34.5346 14.5864 35.2407 15.4575 35.2407H17.8257C18.6981 35.2407 19.4041 34.5334 19.4041 33.6622V31.294C19.4041 30.4216 18.6968 29.7156 17.8257 29.7156ZM15.4575 33.6622V31.294H17.8257V33.6622H15.4575Z"
          fill="#E88236"
        />
        <path
          d="M26.2638 29.8197C26.0911 29.7511 25.9057 29.7156 25.719 29.7168H23.3508C22.4784 29.7168 21.7724 30.4241 21.7724 31.2952V33.6635C21.7724 34.5359 22.4797 35.2419 23.3508 35.2419H25.5362C25.9717 35.2419 26.326 34.8889 26.326 34.4521C26.326 34.0152 25.973 33.6622 25.5362 33.6622H23.3508V31.294L25.6797 31.2851C26.086 31.4438 26.5432 31.2419 26.7019 30.8356C26.8581 30.4343 26.6638 29.981 26.2638 29.8184V29.8197Z"
          fill="#E88236"
        />
        <path
          d="M34.2562 24.4889C29.4613 24.4889 25.573 28.3759 25.573 33.1721C25.573 37.9683 29.46 41.8552 34.2562 41.8552C39.0524 41.8552 42.9394 37.9683 42.9394 33.1721C42.9343 28.3784 39.0499 24.4952 34.2562 24.4889ZM34.2562 40.2768C30.3324 40.2768 27.1514 37.0959 27.1514 33.1721C27.1514 29.2483 30.3324 26.0673 34.2562 26.0673C38.18 26.0673 41.361 29.2483 41.361 33.1721C41.3572 37.0933 38.1787 40.2717 34.2562 40.2768Z"
          fill="#E88236"
        />
        <path
          d="M35.046 32.8457V29.2254C35.046 28.7898 34.693 28.4355 34.2562 28.4355C33.8194 28.4355 33.4663 28.7886 33.4663 29.2254V33.1721C33.4663 33.3816 33.5501 33.5822 33.6975 33.7295L35.2759 35.3079C35.5895 35.6114 36.0886 35.6025 36.3921 35.2889C36.6879 34.9828 36.6879 34.4978 36.3921 34.1917L35.0448 32.8444L35.046 32.8457Z"
          fill="#E88236"
        />
      </g>
      <defs>
        <clipPath id="clip0_2050_8191">
          <rect
            width="46.2222"
            height="48"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddUserIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersEditIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7M11.9999 21.5L14.025 21.095C14.2015 21.0597 14.2898 21.042 14.3721 21.0097C14.4452 20.9811 14.5147 20.9439 14.579 20.899C14.6516 20.8484 14.7152 20.7848 14.8426 20.6574L21.5 14C22.0524 13.4477 22.0523 12.5523 21.5 12C20.9477 11.4477 20.0523 11.4477 19.5 12L12.8425 18.6575C12.7152 18.7848 12.6516 18.8484 12.601 18.921C12.5561 18.9853 12.5189 19.0548 12.4902 19.1278C12.458 19.2102 12.4403 19.2984 12.405 19.475L11.9999 21.5ZM13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Edit05Icon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PieIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2104 15.8899C20.5742 17.3944 19.5792 18.7202 18.3123 19.7512C17.0454 20.7823 15.5452 21.4874 13.9428 21.8047C12.3405 22.1221 10.6848 22.0421 9.12055 21.5717C7.55627 21.1014 6.13103 20.255 4.96942 19.1066C3.80782 17.9582 2.94522 16.5427 2.45704 14.9839C1.96886 13.4251 1.86996 11.7704 2.169 10.1646C2.46804 8.55873 3.1559 7.05058 4.17245 5.77198C5.189 4.49338 6.50329 3.48327 8.0004 2.82995M21.2392 8.17311C21.6395 9.13958 21.8851 10.1613 21.9684 11.2008C21.989 11.4576 21.9993 11.586 21.9483 11.7017C21.9057 11.7983 21.8213 11.8897 21.7284 11.9399C21.6172 11.9999 21.4783 11.9999 21.2004 11.9999H12.8004C12.5204 11.9999 12.3804 11.9999 12.2734 11.9455C12.1793 11.8975 12.1028 11.821 12.0549 11.7269C12.0004 11.62 12.0004 11.48 12.0004 11.1999V2.79995C12.0004 2.52208 12.0004 2.38315 12.0605 2.27193C12.1107 2.17903 12.2021 2.09464 12.2987 2.05204C12.4144 2.00105 12.5428 2.01134 12.7996 2.03193C13.839 2.11527 14.8608 2.36083 15.8272 2.76115C17.0405 3.2637 18.1429 4.00029 19.0715 4.92888C20.0001 5.85747 20.7367 6.95986 21.2392 8.17311Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BarChartSquareIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13V17M16 11V17M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShareThreeDotsIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarPlus = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M21 10H3M16 2V6M8 2V6M18 21V15M15 18H21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrashIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const File02Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12H8M16 16.5H8M16 7.5H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileCheck02Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileDownload02Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileX02Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11H8M10 15H8M16 7H8M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Expand05Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileDownload03Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 15L12 18M12 18L15 15M12 18L12 12M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XClose = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const User01Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterLinesIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12H18M3 6H21M9 18H15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ChevronRightIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18L15 12L9 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Copy05Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeOffIcon = ({ color = 'black' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeOnIcon = ({ color = 'black' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Calendar01Icon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchMdIcon = ({
  color = 'black',
  height = '24',
  width = '24'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserEditIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5ZM11 21L14.1014 20.1139C14.2499 20.0715 14.3241 20.0502 14.3934 20.0184C14.4549 19.9902 14.5134 19.9558 14.5679 19.9158C14.6293 19.8707 14.6839 19.8161 14.7932 19.7068L21.25 13.25C21.9404 12.5597 21.9404 11.4403 21.25 10.75C20.5597 10.0596 19.4404 10.0596 18.75 10.75L12.2932 17.2068C12.1839 17.3161 12.1293 17.3707 12.0842 17.4321C12.0442 17.4866 12.0098 17.5451 11.9816 17.6066C11.9497 17.6759 11.9285 17.7501 11.8861 17.8987L11 21Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HeaderBellIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDownIcon = ({ color = '#1F2933' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 6L8.5 10L12.5 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxCheckedIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#F4C24A" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#F4C24A" />
      <path
        d="M12 5L6.5 10.5L4 8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxIcon = ({ color = 'black' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#ABB4BD" />
    </svg>
  );
};

export const VideoCallIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H12.2C13.8802 5 14.7202 5 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C17 7.27976 17 8.11984 17 9.8V14.2C17 15.8802 17 16.7202 16.673 17.362C16.3854 17.9265 15.9265 18.3854 15.362 18.673C14.7202 19 13.8802 19 12.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Text01Icon = ({ color = 'black' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4C1 3.06812 1 2.60218 1.15224 2.23463C1.35523 1.74458 1.74458 1.35523 2.23463 1.15224C2.60218 1 3.06812 1 4 1H14C14.9319 1 15.3978 1 15.7654 1.15224C16.2554 1.35523 16.6448 1.74458 16.8478 2.23463C17 2.60218 17 3.06812 17 4M6 17H12M9 1V17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MinusIcon = ({ color = 'black' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1H15"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ color = 'black' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5V19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12H19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeftIcon = ({ color = 'black' }) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 7H1M1 7L7 13M1 7L7 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronLeftIcon = ({ color = 'black' }) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 13L1 7L7 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlarmClockIcon = ({ color = 'black' }) => (
  <svg
    width="61"
    height="60"
    viewBox="0 0 61 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7.5L5.5 15M55.5 15L48 7.5M15.5 47.5L10.5 52.5M45.5 47.5L50.5 52.5M23 33.75L28 38.75L39.25 27.5M30.5 52.5C35.8043 52.5 40.8914 50.3929 44.6421 46.6421C48.3929 42.8914 50.5 37.8043 50.5 32.5C50.5 27.1957 48.3929 22.1086 44.6421 18.3579C40.8914 14.6071 35.8043 12.5 30.5 12.5C25.1957 12.5 20.1086 14.6071 16.3579 18.3579C12.6071 22.1086 10.5 27.1957 10.5 32.5C10.5 37.8043 12.6071 42.8914 16.3579 46.6421C20.1086 50.3929 25.1957 52.5 30.5 52.5Z"
      stroke={color}
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProductIcon = ({ color = '#1F2933' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 20.9004V13.9004M12 20.9004V10.9004M4 20.9004L4 16.9004M13.4067 5.9279L18.5751 7.86606M10.7988 6.30131L5.20023 10.5002M21.0607 7.33973C21.6464 7.92552 21.6464 8.87526 21.0607 9.46105C20.4749 10.0468 19.5251 10.0468 18.9393 9.46105C18.3536 8.87526 18.3536 7.92552 18.9393 7.33973C19.5251 6.75394 20.4749 6.75394 21.0607 7.33973ZM5.06066 10.3397C5.64645 10.9255 5.64645 11.8753 5.06066 12.4611C4.47487 13.0468 3.52513 13.0468 2.93934 12.4611C2.35355 11.8753 2.35355 10.9255 2.93934 10.3397C3.52513 9.75394 4.47487 9.75394 5.06066 10.3397ZM13.0607 4.33973C13.6464 4.92552 13.6464 5.87526 13.0607 6.46105C12.4749 7.04684 11.5251 7.04684 10.9393 6.46105C10.3536 5.87526 10.3536 4.92552 10.9393 4.33973C11.5251 3.75394 12.4749 3.75394 13.0607 4.33973Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResourceHomeIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.266 3.22454C14.8561 2.90575 14.6512 2.74635 14.4249 2.68508C14.2252 2.63102 14.0148 2.63102 13.8151 2.68508C13.5888 2.74635 13.3839 2.90575 12.974 3.22454L5.06128 9.37886C4.53235 9.79025 4.26789 9.99594 4.07736 10.2535C3.90859 10.4817 3.78286 10.7388 3.70636 11.0121C3.62 11.3206 3.62 11.6557 3.62 12.3258V20.7665C3.62 22.0733 3.62 22.7267 3.87431 23.2258C4.09802 23.6649 4.45497 24.0218 4.89402 24.2455C5.39314 24.4999 6.04654 24.4999 7.35333 24.4999H9.68666C10.0134 24.4999 10.1767 24.4999 10.3015 24.4363C10.4113 24.3804 10.5005 24.2911 10.5564 24.1814C10.62 24.0566 10.62 23.8932 10.62 23.5665V15.8665C10.62 15.2131 10.62 14.8864 10.7472 14.6369C10.859 14.4173 11.0375 14.2389 11.257 14.127C11.5066 13.9999 11.8333 13.9999 12.4867 13.9999H15.7533C16.4067 13.9999 16.7334 13.9999 16.983 14.127C17.2025 14.2389 17.381 14.4173 17.4928 14.6369C17.62 14.8864 17.62 15.2131 17.62 15.8665V23.5665C17.62 23.8932 17.62 24.0566 17.6836 24.1814C17.7395 24.2911 17.8287 24.3804 17.9385 24.4363C18.0633 24.4999 18.2266 24.4999 18.5533 24.4999H20.8867C22.1935 24.4999 22.8468 24.4999 23.346 24.2455C23.785 24.0218 24.142 23.6649 24.3657 23.2258C24.62 22.7267 24.62 22.0733 24.62 20.7665V12.3258C24.62 11.6557 24.62 11.3206 24.5336 11.0121C24.4571 10.7388 24.3314 10.4817 24.1626 10.2535C23.9721 9.99594 23.7076 9.79025 23.1787 9.37886L15.266 3.22454Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResourceHistoryIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7 14.3999L20.7005 12.3999L18.7 14.3999M21 12.8999C21 17.8705 16.9706 21.8999 12 21.8999C7.02944 21.8999 3 17.8705 3 12.8999C3 7.92934 7.02944 3.8999 12 3.8999C15.3019 3.8999 18.1885 5.67804 19.7545 8.32899M12 7.8999V12.8999L15 14.8999"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResourceFavouritesIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9932 6.03572C9.9938 3.6983 6.65975 3.06954 4.15469 5.20992C1.64964 7.35029 1.29697 10.9289 3.2642 13.4603C4.89982 15.565 9.84977 20.004 11.4721 21.4407C11.6536 21.6015 11.7444 21.6818 11.8502 21.7134C11.9426 21.741 12.0437 21.741 12.1361 21.7134C12.2419 21.6818 12.3327 21.6015 12.5142 21.4407C14.1365 20.004 19.0865 15.565 20.7221 13.4603C22.6893 10.9289 22.3797 7.32777 19.8316 5.20992C17.2835 3.09206 13.9925 3.6983 11.9932 6.03572Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResourceLibraryIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21.9004L11.8999 21.7503C11.2053 20.7083 10.858 20.1874 10.3991 19.8102C9.99286 19.4763 9.52476 19.2258 9.02161 19.073C8.45325 18.9004 7.82711 18.9004 6.57482 18.9004H5.2C4.07989 18.9004 3.51984 18.9004 3.09202 18.6824C2.71569 18.4907 2.40973 18.1847 2.21799 17.8084C2 17.3805 2 16.8205 2 15.7004V7.10039C2 5.98029 2 5.42023 2.21799 4.99241C2.40973 4.61609 2.71569 4.31012 3.09202 4.11838C3.51984 3.90039 4.07989 3.90039 5.2 3.90039H5.6C7.84021 3.90039 8.96031 3.90039 9.81596 4.33636C10.5686 4.71986 11.1805 5.33178 11.564 6.08443C12 6.94008 12 8.06018 12 10.3004M12 21.9004V10.3004M12 21.9004L12.1001 21.7503C12.7947 20.7083 13.142 20.1874 13.6009 19.8102C14.0071 19.4763 14.4752 19.2258 14.9784 19.073C15.5467 18.9004 16.1729 18.9004 17.4252 18.9004H18.8C19.9201 18.9004 20.4802 18.9004 20.908 18.6824C21.2843 18.4907 21.5903 18.1847 21.782 17.8084C22 17.3805 22 16.8205 22 15.7004V7.10039C22 5.98029 22 5.42023 21.782 4.99241C21.5903 4.61609 21.2843 4.31012 20.908 4.11838C20.4802 3.90039 19.9201 3.90039 18.8 3.90039H18.4C16.1598 3.90039 15.0397 3.90039 14.184 4.33636C13.4314 4.71986 12.8195 5.33178 12.436 6.08443C12 6.94008 12 8.06018 12 10.3004"
      stroke="#1F2933"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContentSpaceIcon = ({ color = 'black' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57181 21.9004C8.90661 21.2602 10.41 20.9004 12 20.9004C13.59 20.9004 15.0934 21.2602 16.4282 21.9004M6.8 17.9004H17.2C18.8802 17.9004 19.7202 17.9004 20.362 17.5734C20.9265 17.2858 21.3854 16.8268 21.673 16.2624C22 15.6206 22 14.7805 22 13.1004V8.70039C22 7.02023 22 6.18015 21.673 5.53842C21.3854 4.97393 20.9265 4.51499 20.362 4.22737C19.7202 3.90039 18.8802 3.90039 17.2 3.90039H6.8C5.11984 3.90039 4.27976 3.90039 3.63803 4.22737C3.07354 4.51499 2.6146 4.97393 2.32698 5.53842C2 6.18015 2 7.02023 2 8.70039V13.1004C2 14.7805 2 15.6206 2.32698 16.2624C2.6146 16.8268 3.07354 17.2858 3.63803 17.5734C4.27976 17.9004 5.11984 17.9004 6.8 17.9004Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
